// import React, { useEffect, useState } from 'react'
// import Header from '../../layouts/Header';
// import { Button, Card, Col, Container, Form, Image, Modal, Row, Spinner, Tab, Table, Tabs } from 'react-bootstrap';
// import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';
// import Select from "react-select";
// import DatePicker from 'react-datepicker';
// import makeAnimated from "react-select/animated";
// import { useSelector } from 'react-redux';

// const AdvertisementMgt = () => {

//     const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
//     const [skin, setSkin] = useState(currentSkin);
//     const { access } = useSelector((state) => state.login);
//     const { loginEmail } = useSelector((state) => state.login);
//     const email = loginEmail || localStorage.getItem("email");
//     const [addAccess, setAddAccess] = useState([]);
    
//     console.log("Access :", access);
    
//     useEffect(() => {
//         if (Array.isArray(access)) {
//             const filteredAccess = access?.filter((perm) =>
//                 perm?.startsWith("AdvertisementMgt:")
//             );
//             setAddAccess(filteredAccess);
//         } 
//     }, [access]);
    
//     console.log("Menu Access:", addAccess);

//     const accessToken = localStorage.getItem("authToken");
//     const [inputData, setInputData] = useState({
//         title: "",
//         type: "",
//         sequenceNo: "",
//         product: "",
//         isTopImage: "",
//         isBottomImage: "",
//         link: ""
//     });
//     const [listLoading, setListLoading] = useState(false);
//     const [topImageAdd, setTopImageAdd] = useState([]);
//     const [bottomImageAdd, setBottomImageAdd] = useState({});
//     const [activeTab, setActiveTab] = useState("CLICKABLE");
//     const [clickableAdvertisementData, setClickableAdvertisementData] = useState([]);
//     const [nonClickableAdvertisementData, setNonClickableAdvertisementData] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const animatedComponents = makeAnimated();
//     const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
//     const [outlets, setOutlets] = useState([]);
//     const [openEditModal, setOpenEditModal] = useState(false);
//     const [editedData, setEditedData] = useState({});
//     const [productsList, setProductsList] = useState([]);
//     const [toDate, setToDate] = useState(null);
//     const [fromDate, setFromDate] = useState(null);
//     const [openViewModal, setOpenViewModal] = useState(false);
//     const [singleAdData, setSingleAdData] = useState("");
//     const [openDeleteModal, setOpenDeleteModal] = useState(false);
//     const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
//     const [adId, setAdId] = useState('');
//     const [openAddModal, setOpenAddModal] = useState(false);
//     const [image, setImage] = useState(null);
//     const [isOpenUpdateImageModal, setIsOpenUpdateImageModal] = useState(false);
//     const [isImageUpdating, setIsImageUpdating] = useState(false);
//     const [isRefreshBtnLoading, setIsRefreshBtnLoading] = useState(false);

//     const outletData = outlets?.map((outlet) => ({
//         value: outlet._id,
//         label: `${outlet.name} (${outlet.city})`,
//     }));

//     const customStyles = {
//         control: (provided, state) => ({
//             ...provided,
//             width: "100%",
//             borderRadius: "6px",
//             minWidth: "200px",
//             borderColor: state.isFocused ? "#80bdff" : "#ced4da",
//             boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
//             "&:hover": {
//                 borderColor: state.isFocused ? "#80bdff" : "#ced4da",
//             },
//         }),
//         placeholder: (provided) => ({
//             ...provided,
//             color: "#6c757d",
//         }),
//     };

//     const handleTabChange = (tab) => {
//         setActiveTab(tab);
//     };

//     const getAdvertisementList = async () => {
//         setListLoading(true);
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };
//             const response = await axiosInstance.get("advertisement", { headers });

//             if (response?.data?.status === true) {
//                 const totalNonClickableAdvertisements=response?.data?.data?.advertisements.nonClickableAdvertisements;
//                 console.log("Total Non Clickable Add :", totalNonClickableAdvertisements);
                
//                 const nonClickableAdvertisements=totalNonClickableAdvertisements.filter(ad=>ad.isTopImage===false && ad.isBottomImage===false);
//                 const topImageAdvertisement=totalNonClickableAdvertisements.filter(ad=>ad.isTopImage===true);
//                 const bottomImageAdvertisement=totalNonClickableAdvertisements.find(ad=>ad.isBottomImage===true);
//                 setClickableAdvertisementData(
//                     response?.data?.data?.advertisements.clickableAdvertisements
//                 );
//                 console.log("Top Images :", topImageAdvertisement);
                
//                 setNonClickableAdvertisementData(nonClickableAdvertisements);
//                 setTopImageAdd(topImageAdvertisement);
//                 setBottomImageAdd(bottomImageAdvertisement);
                
//             }
//         } catch (error) {
//             if (error.response && error.response?.data?.status === false) {
//                 let errorMessage = error.response.data.error;
//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } finally {
//             setListLoading(false);
//         }
//     };

//     const getOutlets = async () => {
//         try {
//           const headers = {
//             Authorization: `Bearer ${accessToken}`,
//           };
//           const response = await axiosInstance.get("outlet", { headers });
    
//           if (response?.data?.status === true) {
            
//             let filteredOutlets = response?.data?.data?.outlets?.filter((act) => act?.status === "ACTIVE");
            
//             setOutlets(filteredOutlets);
//           }
//         } catch (error) {
//           if (error.response && error.response?.data?.status === false) {
//             let errorMessage = error.response.data.error;
//             toast.error(errorMessage, {
//               position: "top-right",
//               autoClose: 3000,
//               theme: "colored",
//             });
//           }
//         }
//     };

//     const getProductsList = async () => {
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };
//             const response = await axiosInstance.get("product", { headers });
//             if (response?.data?.status === true) {
//                 setProductsList(response?.data?.data?.products);
//             }
//         } catch (error) {
//             if (error.response && error.response?.data?.status === false) {
//                 let errorMessage = error.response.data.error;
//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         }
//     };

//     const handleOpenViewModal = (id) => {
//         setOpenViewModal(true);
//         getSingleAdvertisement(id);
//     };

//     const getSingleAdvertisement = async (id) => {
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };
//             const response = await axiosInstance.get(`advertisement?_id=${id}`, { headers });

//             if (response?.data?.status === true) {
//                 setSingleAdData(response?.data?.data?.advertisements);
//             }
//         } catch (error) {
//             if (error.response && error.response?.data?.status === false) {
//                 let errorMessage = error.response.data.error;
//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         }
//     };

//     const handleOpenAddModal = () => {
//         setOpenAddModal(true);
//     }

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setInputData((prev) => ({ ...prev, [name]: value }));
//     }

//     const handleImageChange = () => {
//         const input = document.getElementById("imageInput");
//         const file = input.files[0];
    
//         if (file) {
//           const reader = new FileReader();
    
//           // reader.onloadend = () => {
//           //   const image = new Image();
//           //   image.src = reader.result;
    
//           //   image.onload = () => {
//           //     const width = image.width;
//           //     const height = image.height;
    
//           //     const aspectRatio = width / height;
//           //     const targetAspectRatio = 16 / 9;
    
//           //     if (Math.abs(aspectRatio - targetAspectRatio) < 0.01) {
//           //       alert("Image dimensions are valid!");
//           //       setImage(file);
//           //     } else {
//           //       alert(
//           //         "Image dimensions are not valid. Please choose an image with a 16:9 aspect ratio."
//           //       );
//           //       input.value = "";
//           //     }
//           //   };
//           // };
    
//           setImage(file);
    
//           reader.readAsDataURL(file);
//         }
//     };

//     const handleSelectChange = (selected) => {
//         setSelectedExcludedOutlets(selected);
//     }

//     const addAdvertisement = async (e) => {
//         e.preventDefault();
//         setIsLoading(true)
//         try {
//             // Format the dates
//             const updatedStartDate = fromDate
//                 ? new Date(fromDate.getTime() - fromDate.getTimezoneOffset() * 60000)
//                         .toISOString()
//                         .split("T")[0]
//                 : null;
        
//             const updatedEndDate = toDate
//                 ? new Date(toDate.getTime() - toDate.getTimezoneOffset() * 60000)
//                         .toISOString()
//                         .split("T")[0]
//                 : null;
    
    
//             console.log("updatedStartDate :", updatedStartDate);
//             console.log("updatedEndDate :", updatedEndDate);
        
//             let selectOutlets = selectedExcludedOutlets.map((val) => val?.value);
//             console.log("Selected Outlets :", selectOutlets);
            
//             let newInputData = {
//                 ...inputData,
//                 excludedOutlets: selectOutlets
//             }
    
//             const formData = new FormData();
//             formData.append("title", newInputData.title);
//             formData.append("type", newInputData.type);
//             formData.append("sequenceNo", newInputData.sequenceNo);
//             if(updatedStartDate !== null){
//                 formData.append("validityStartDate", updatedStartDate);
//             }
//             if(updatedEndDate !== null){
//                 formData.append("validityEndDate", updatedEndDate);
//             }
//             if (newInputData?.product !== "") {
//                 formData.append("product", newInputData.product);
//             }
//             if (newInputData?.isTopImage !== "") {
//                 formData.append("isTopImage", newInputData.isTopImage);
//             }
//             if (newInputData?.isBottomImage !== "") {
//                 formData.append("isBottomImage", newInputData.isBottomImage);
//             }
//             if (newInputData?.link !== "") {
//                 formData.append("link", newInputData.link);
//             }
//             formData.append("adImage", image);
        
//             // Append each excluded outlet as excludedOutlets[0], excludedOutlets[1], etc.
//             if (selectOutlets?.length > 0) {
//                 selectOutlets.forEach((outlet, index) => {
//                 formData.append(`excludedOutlets[${index}]`, outlet);
//                 });
//             }
        
//             const headers = {
//                 "Content-Type": "multipart/form-data",
//                 Authorization: `Bearer ${accessToken}`,
//             };
        
//             const response = await axiosInstance.post("advertisement", formData, {
//                 headers,
//             });
        
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "light",
//                 });
//                 e.target.reset();
//                 setInputData({
//                     title: '',
//                     type: '',
//                     sequenceNo: '',
//                     product: '',
//                     link: '',
//                     isTopImage: '',
//                     isBottomImage: ''
//                 })
//                 setFromDate(null);
//                 setToDate(null);
//                 getAdvertisementList();
//                 setOpenAddModal(false);
//                 setSelectedExcludedOutlets([]);
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let errorMessage = '';
//                 if ( error.response?.status === 406 ) {
//                     errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
//                 }
//                 else if ( error.response?.status === 412 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 } else if (error.response?.status === 500) {
//                     errorMessage = error?.response?.data?.error
//                 }
        
//                 toast.error(errorMessage, {
//                 position: "top-right",
//                 autoClose: 3000,
//                 theme: "light",
//                 });
//             }
//         } finally {
//           setIsLoading(false);
//         }
//     }

//     const handleCloseAddModal = () => {
//         setOpenAddModal(false);
//         setInputData({
//             title: "",
//             type: "",
//             sequenceNo: "",
//             product: "",
//             isTopImage: "",
//             isBottomImage: "",
//             link: ""
//         })
//     }

//     const handleOpenEditModal = (data) => {
//         console.log("Edited Data :", data);
        
//         setOpenEditModal(true);
//         setEditedData({
//             _id: data?._id,
//             title: data?.title,
//             type: data?.type,
//             sequenceNo: data?.sequenceNo,
//             product: data?.product?._id,
//             isTopImage: data?.isTopImage,
//             isBottomImage: data?.isBottomImage,
//             link: data?.link
//         })
//         // Convert ISO string to Date object
//         setFromDate(data?.validityStartDate ? new Date(data.validityStartDate) : null);
//         setToDate(
//             data?.validityEndDate
//               ? new Date(new Date(data.validityEndDate).setDate(new Date(data.validityEndDate).getDate() - 1))
//               : null
//         );
        
//         let selectedExOutlet = data?.excludedOutlets;
//         let mappedSelectedExOutlet = selectedExOutlet?.map((m) =>
//         ({
//             value: m?._id,
//             label: m?.name
//         }))
//         setSelectedExcludedOutlets(mappedSelectedExOutlet);
//     };

//     const handleEditSelectChange = (selected) => {
//         setSelectedExcludedOutlets(selected);
//     };

//     const handleEditChange = (e) => {
//         const { name, value } = e.target;
//         setEditedData((prev) => ({ ...prev, [name]: value }))
//     };

//     const handleFromDateChange = (date) => {
//         setFromDate(date);
//     };
    
//     const handleToDateChange = (date) => {        
//         setToDate(date);
//     };

//     const handleEditSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
        
//         try {
//             // Check if only one of the dates is selected
//             if ((fromDate && !toDate) || (!fromDate && toDate)) {
//                 toast.error("Please select both start date and end date", {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//                 setIsLoading(false);
//                 return;
//             }
//             // Format the dates
//             const updatedStartDate = fromDate
//                 ? new Date(fromDate.getTime() - fromDate.getTimezoneOffset() * 60000)
//                         .toISOString()
//                         .split("T")[0]
//                 : null;

//             const updatedEndDate = toDate
//                 ? new Date(toDate.getTime() - toDate.getTimezoneOffset() * 60000)
//                         .toISOString()
//                         .split("T")[0]
//                 : null;

//             let selectedExOutlets = selectedExcludedOutlets?.map((ex) => ex?.value);
//             let newEditedData = {
//                 ...editedData,
//                 excludedOutlets: selectedExOutlets
//             }

//             const formData = new FormData();
//             formData.append("_id", newEditedData?._id)
//             formData.append("title", newEditedData.title);
//             formData.append("type", newEditedData.type);
//             formData.append("sequenceNo", newEditedData.sequenceNo);
//             formData.append("validityStartDate", updatedStartDate);
//             formData.append("validityEndDate", updatedEndDate);
//             if (newEditedData?.product !== "" && newEditedData?.product !== undefined && newEditedData?.product !== null) {                
//                 formData.append("product", newEditedData?.product);
//             }
//             if (newEditedData?.isTopImage !== ""){
//                 formData.append("isTopImage", newEditedData?.isTopImage);
//             }
//             if (newEditedData?.link !== ""){
//                 formData.append("link", newEditedData?.link);
//             }
//             if (newEditedData?.isBottomImage !== ""){
//                 formData.append("isBottomImage", newEditedData?.isBottomImage);
//             }

//             // Check if excluded outlets are empty
//             if (selectedExOutlets?.length === 0 || selectedExOutlets === undefined) {
//                 formData.append("excludedOutlets", null);
//             } else {
//                 selectedExOutlets.forEach((outlet, index) => {
//                 formData.append(`excludedOutlets[${index}]`, outlet);
//                 });
//             }

//             const headers = {
//                 "Content-Type": "multipart/form-data",
//                 Authorization: `Bearer ${accessToken}`,
//             };

//             const response = await axiosInstance.put("advertisement", formData, {
//                 headers,
//             });

//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//                 setOpenEditModal(false);
//                 getAdvertisementList();
                
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let errorMessage = '';
//                 if ( error.response?.status === 406 ) {
//                     errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
//                 }
//                 else if ( error.response?.status === 404 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 }
//                 else if ( error.response?.status === 412 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 } else if (error.response?.status === 500) {
//                     errorMessage = error?.response?.data?.error
//                 }

//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleOpenDeleteModal = (id) => {
//         setOpenDeleteModal(true);
//         setAdId(id);
//     };

//     const deleteAdvertisement = async (e) => {
//         e.preventDefault();
//         setIsDeleteBtnLoading(true);
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };

//             const data = {
//                 _id: adId,
//             };
//             const response = await axiosInstance.delete(`advertisement`, { data, headers });
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//                 getAdvertisementList();
//                 setOpenDeleteModal(false);
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let errorMessage = '';
//                 if (
//                     error.response?.status === 406
//                 ) {
//                     errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
//                 }
//                 else if (
//                     error.response?.status === 412
//                 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 } else if (error.response?.status === 500) {
//                     errorMessage = error?.response?.data?.error
//                 }

//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } finally {
//             setIsDeleteBtnLoading(false);
//         }
//     };

//     const openUpdateImageModal = (data) => {
//         setEditedData((prev) => ({
//             ...prev,
//             _id: data?._id
//         }))
//         setIsOpenUpdateImageModal(true)
//     }

//     const handleEditImageChange = (e) => {
//         const input = document.getElementById("imageInput");
//         const file = input.files[0];

//         if (file) {
//             const reader = new FileReader();

//             // <--------------- This is Validation For Updating Image --------------> 
//             // reader.onloadend = () => {
//             //     const image = new Image();
//             //     image.src = reader.result;

//             //     image.onload = () => {
//             //         const width = image.width;
//             //         const height = image.height;

//             //         const aspectRatio = width / height;
//             //         const targetAspectRatio = 16 / 9;

//             //         if (Math.abs(aspectRatio - targetAspectRatio) < 0.01) {
//             //             alert("Image dimensions are valid!");
//             //             setImage(file);
//             //         } else {
//             //             alert(
//             //                 "Image dimensions are not valid. Please choose an image with a 16:9 aspect ratio."
//             //             );
//             //             input.value = "";
//             //         }
//             //     };
//             // };

//             setImage(file);

//             reader.readAsDataURL(file);
//         }
//     };

//     const handleEditImage = async () => {
//         // e.preventDefault()
//         console.log("HEloo");
        
//         setIsImageUpdating(true);

//         try {
//             const formData = new FormData();
//             formData.append("_id", editedData?._id)
//             formData.append("adImage", image);

//             const headers = {
//                 "Content-Type": "multipart/form-data",
//                 Authorization: `Bearer ${accessToken}`,
//             };

//             const response = await axiosInstance.put(`advertisement`, formData, {
//                 headers,
//             });

//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//                 // e.target.reset()
//                 setIsOpenUpdateImageModal(false)
//                 getAdvertisementList()
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let errorMessage = '';
//                 if (
//                     error.response?.status === 406
//                 ) {
//                     errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
//                 }
//                 else if (
//                     error.response?.status === 412
//                 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 } else if (error.response?.status === 500) {
//                     errorMessage = error?.response?.data?.error
//                 }

//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } finally {
//             setIsImageUpdating(false)
//         }
//     };

//     const handleRefresh = async() => {
//         setIsRefreshBtnLoading(true);
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`
//             }
//             const response = await axiosInstance.get('advertisement/clear-advertisement-cache', { headers });
            
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.message, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let errorMessage = '';
//                 if ( error.response?.status === 406 ) {
//                     errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
//                 }
//                 else if ( error.response?.status === 404 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 }
//                 else if ( error.response?.status === 412 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 } else if (error.response?.status === 500) {
//                     errorMessage = error?.response?.data?.error
//                 }

//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } finally {
//             setIsRefreshBtnLoading(false);
//         }
//     };

//     useEffect(() => {
//         getAdvertisementList();
//         getOutlets();
//         getProductsList();
//     }, [])

//     return (
//         <React.Fragment>
//             <Header onSkin={setSkin} />
//             <div className="main main-app p-3 p-lg-4">
//                 <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
//                     <Row className="pt-4">
//                         <Col>
//                             <h5 className="fw-semibold">ADVERTISEMENT MANAGEMENT</h5>
//                         </Col>
//                     </Row>

//                     <Row className='justify-content-between' style={{ backgroundColor: "whitesmoke" }}>
//                         <Col lg="3" className="d-flex justify-content-end flex-column  mt-4">
//                             <Button
//                               variant="success"
//                               className="fw-semibold"
//                               onClick={handleRefresh}
//                             >
//                                 {isRefreshBtnLoading ? <Spinner size='sm' /> : (
//                                     <>
//                                         <i className="ri-refresh-line" style={{ marginRight: "5px" }}></i>
//                                         Clear or Refresh Cache
//                                     </>
//                                 ) }
                                
//                             </Button>
//                         </Col>
//                         {(addAccess?.includes("AdvertisementMgt:add") || email === "contact@xpansecafe.com") && (
//                             <Col lg="3" className="d-flex justify-content-end flex-column  mt-4">
//                                 <Button
//                                 variant="primary"
//                                 className="fw-semibold"
//                                 onClick={handleOpenAddModal}
//                                 >
//                                     <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
//                                     Add New Advertisement
//                                 </Button>
//                             </Col>
//                         )}
//                     </Row>

//                     <Row style={{ backgroundColor: "whitesmoke" }}>
//                         {/* <Col> */}
//                             <Container className="my-4">
//                                 <Tabs
//                                     activeKey={activeTab}
//                                     onSelect={handleTabChange}
//                                     className="mb-4"
//                                     style={{
//                                         backgroundColor: '#f8f9fa',
//                                         borderRadius: '8px',
//                                         padding: '10px',
//                                         // boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//                                     }}
//                                 >
//                                     <Tab
//                                         eventKey="CLICKABLE"
//                                         title="CLICKABLE"
//                                         style={{ fontSize: '16px', fontWeight: '500', color: '#495057' }}
//                                     >
//                                         <Row className="mt-3 g-3">
//                                             {listLoading ? (
//                                                 // Skeleton Loading for Clickable Ads
//                                                 Array.from({ length: 4 }).map((_, index) => (
//                                                     <Col key={`skeleton-clickable-${index}`} lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100 skeleton-card"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                             }}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 {/* Skeleton for Image */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '100%',
//                                                                         height: '200px',
//                                                                         borderRadius: '8px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         marginBottom: '15px'
//                                                                     }}
//                                                                 />
//                                                                 {/* Skeleton for Title */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '80%',
//                                                                         height: '20px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         borderRadius: '4px',
//                                                                         margin: '0 auto'
//                                                                     }}
//                                                                 />
//                                                             </Card.Body>
//                                                             {/* Skeleton for Action Buttons */}
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {[1, 2, 3].map((btnIndex) => (
//                                                                     <div
//                                                                         key={btnIndex}
//                                                                         style={{
//                                                                             width: '60px',
//                                                                             height: '32px',
//                                                                             background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                             backgroundSize: '200% 100%',
//                                                                             animation: 'skeletonPulse 1.5s infinite',
//                                                                             borderRadius: '4px',
//                                                                         }}
//                                                                     />
//                                                                 ))}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 ))
//                                             ) : clickableAdvertisementData?.length === 0 ? (
//                                                 // Empty State
//                                                 <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
//                                                     <div className="text-center">
//                                                         <div className="text-muted mb-2">
//                                                             <i className="bi bi-megaphone" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
//                                                         </div>
//                                                         <p className="text-muted">No clickable advertisements found</p>
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 // Actual Clickable Ads
//                                                 clickableAdvertisementData.map((ad) => (
//                                                     <Col key={ad.id} lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                                 transition: 'transform 0.2s, box-shadow 0.2s',
//                                                                 cursor: 'pointer',
//                                                             }}
//                                                             onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
//                                                             onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 <Image
//                                                                     src={ad.adImagePath}
//                                                                     onClick={() => openUpdateImageModal(ad)}
//                                                                     alt="ad-pic"
//                                                                     fluid
//                                                                     style={{
//                                                                         borderRadius: '8px',
//                                                                         maxHeight: '200px',
//                                                                         objectFit: 'cover',
//                                                                     }}
//                                                                 />
//                                                                 <h5
//                                                                     className="mt-3"
//                                                                     style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
//                                                                 >
//                                                                     {ad.title.toUpperCase()}
//                                                                 </h5>
//                                                             </Card.Body>
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {(addAccess?.includes("AdvertisementMgt:get") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="View"
//                                                                         className='text-success'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenViewModal(ad._id)}
//                                                                     >
//                                                                         <i className="bi bi-eye" style={{ fontSize: '15px' }}></i> View
//                                                                     </Button>
//                                                                 )}
//                                                                 {(addAccess?.includes("AdvertisementMgt:udpate") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         className='text-primary'
//                                                                         variant="light"
//                                                                         title="Edit"
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenEditModal(ad)}
//                                                                     >
//                                                                         <i className="bi bi-pencil" style={{ fontSize: '15px' }}></i> Edit
//                                                                     </Button>
//                                                                 )}
//                                                                 {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         className='text-danger'
//                                                                         variant="light"
//                                                                         title="Delete"
//                                                                         onClick={() => handleOpenDeleteModal(ad._id)}
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
                                                                        
//                                                                     >
//                                                                         <i className="bi bi-trash" style={{ fontSize: '15px' }}></i> Delete
//                                                                     </Button>
//                                                                 )}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 ))
//                                             )}
//                                         </Row>
//                                     </Tab>

//                                     <Tab
//                                         eventKey="NON CLICKABLE"
//                                         title="NON CLICKABLE"
//                                         style={{ fontSize: '16px', fontWeight: '500', color: '#495057' }}
//                                     >
//                                         <Row className="mt-3 g-3">
//                                             {listLoading ? (
//                                                 // Skeleton Loading for Non-Clickable Ads
//                                                 Array.from({ length: 4 }).map((_, index) => (
//                                                     <Col key={`skeleton-nonclickable-${index}`} lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100 skeleton-card"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                             }}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 {/* Skeleton for Image */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '100%',
//                                                                         height: '200px',
//                                                                         borderRadius: '8px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         marginBottom: '15px'
//                                                                     }}
//                                                                 />
//                                                                 {/* Skeleton for Title */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '80%',
//                                                                         height: '20px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         borderRadius: '4px',
//                                                                         margin: '0 auto'
//                                                                     }}
//                                                                 />
//                                                             </Card.Body>
//                                                             {/* Skeleton for Action Buttons */}
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {[1, 2, 3].map((btnIndex) => (
//                                                                     <div
//                                                                         key={btnIndex}
//                                                                         style={{
//                                                                             width: '60px',
//                                                                             height: '32px',
//                                                                             background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                             backgroundSize: '200% 100%',
//                                                                             animation: 'skeletonPulse 1.5s infinite',
//                                                                             borderRadius: '4px',
//                                                                         }}
//                                                                     />
//                                                                 ))}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 ))
//                                             ) : nonClickableAdvertisementData.length === 0 ? (
//                                                 // Empty State
//                                                 <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
//                                                     <div className="text-center">
//                                                         <div className="text-muted mb-2">
//                                                             <i className="bi bi-image" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
//                                                         </div>
//                                                         <p className="text-muted">No non-clickable advertisements found</p>
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 // Actual Non-Clickable Ads
//                                                 nonClickableAdvertisementData.map((ad) => (
//                                                     <Col key={ad.id} lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                                 transition: 'transform 0.2s, box-shadow 0.2s',
//                                                                 cursor: 'pointer',
//                                                             }}
//                                                             onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
//                                                             onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 <Image
//                                                                     src={ad.adImagePath}
//                                                                     onClick={() => openUpdateImageModal(ad)}
//                                                                     alt="ad-pic"
//                                                                     fluid
//                                                                     style={{
//                                                                         borderRadius: '8px',
//                                                                         maxHeight: '200px',
//                                                                         objectFit: 'cover',
//                                                                     }}
//                                                                 />
//                                                                 <h5
//                                                                     className="mt-3"
//                                                                     style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
//                                                                 >
//                                                                     {ad.title.toUpperCase()}
//                                                                 </h5>
//                                                             </Card.Body>
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {(addAccess?.includes("AdvertisementMgt:get") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="View"
//                                                                         size='sm'
//                                                                         className='text-success'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenViewModal(ad._id)}
//                                                                     >
//                                                                         <i className="bi bi-eye" style={{ fontSize: '15px' }}></i> View
//                                                                     </Button>
//                                                                 )}
//                                                                 {(addAccess?.includes("AdvertisementMgt:update") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="Edit"
//                                                                         size='sm'
//                                                                         className='text-primary'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenEditModal(ad)}
//                                                                     >
//                                                                         <i className="bi bi-pencil" style={{ fontSize: '15px' }}></i> Edit
//                                                                     </Button>
//                                                                 )}
//                                                                 {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="Delete"
//                                                                         size='sm'
//                                                                         className='text-danger'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenDeleteModal(ad._id)}
//                                                                     >
//                                                                         <i className="bi bi-trash" style={{ fontSize: '15px' }}></i> Delete
//                                                                     </Button>
//                                                                 )}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 ))
//                                             )}
//                                         </Row>
//                                     </Tab>

//                                     <Tab
//                                         eventKey="TOP & BOTTOM IMAGES"
//                                         title="TOP & BOTTOM IMAGES"
//                                         style={{ fontSize: '16px', fontWeight: '500', color: '#495057' }}
//                                     >
//                                         <Row className="mt-3 g-3">
//                                             {listLoading ? (
//                                                 // Skeleton Loading for Top & Bottom Images
//                                                 Array.from({ length: 4 }).map((_, index) => (
//                                                     <Col key={`skeleton-topbottom-${index}`} lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100 skeleton-card"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                             }}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 {/* Skeleton for Image */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '100%',
//                                                                         height: '200px',
//                                                                         borderRadius: '8px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         marginBottom: '15px'
//                                                                     }}
//                                                                 />
//                                                                 {/* Skeleton for Title */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '80%',
//                                                                         height: '20px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         borderRadius: '4px',
//                                                                         margin: '0 auto'
//                                                                     }}
//                                                                 />
//                                                             </Card.Body>
//                                                             {/* Skeleton for Action Buttons */}
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {[1, 2].map((btnIndex) => (
//                                                                     <div
//                                                                         key={btnIndex}
//                                                                         style={{
//                                                                             width: '60px',
//                                                                             height: '32px',
//                                                                             background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                             backgroundSize: '200% 100%',
//                                                                             animation: 'skeletonPulse 1.5s infinite',
//                                                                             borderRadius: '4px',
//                                                                         }}
//                                                                     />
//                                                                 ))}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 ))
//                                             ) : topImageAdd.length === 0 && !bottomImageAdd ? (
//                                                 // Empty State
//                                                 <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
//                                                     <div className="text-center">
//                                                         <div className="text-muted mb-2">
//                                                             <i className="bi bi-layout-three-columns" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
//                                                         </div>
//                                                         <p className="text-muted">No top or bottom images found</p>
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 // Actual Top & Bottom Images
//                                                 <>
//                                                     {topImageAdd.map((ad) => (
//                                                         <Col key={ad.id} lg={3} md={4}>
//                                                             <Card
//                                                                 className="h-100"
//                                                                 style={{
//                                                                     border: '1px solid #e9ecef',
//                                                                     borderRadius: '10px',
//                                                                     transition: 'transform 0.2s, box-shadow 0.2s',
//                                                                     cursor: 'pointer',
//                                                                 }}
//                                                                 onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
//                                                                 onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                                                             >
//                                                                 <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                     <Image
//                                                                         onClick={() => openUpdateImageModal(ad)}
//                                                                         src={ad.adImagePath}
//                                                                         alt="ad-pic"
//                                                                         fluid
//                                                                         style={{
//                                                                             borderRadius: '8px',
//                                                                             maxHeight: '200px',
//                                                                             objectFit: 'cover',
//                                                                         }}
//                                                                     />
//                                                                     <h5
//                                                                         className="mt-3"
//                                                                         style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
//                                                                     >
//                                                                         {ad.title.toUpperCase()}
//                                                                     </h5>
//                                                                 </Card.Body>
//                                                                 <div
//                                                                     className="d-flex justify-content-around p-2"
//                                                                     style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                                 >
//                                                                     {(addAccess?.includes("AdvertisementMgt:get") || email === "contact@xpansecafe.com") && (
//                                                                         <Button
//                                                                             variant="light"
//                                                                             title="View"
//                                                                             size='sm'
//                                                                             className='text-success'
//                                                                             style={{ padding: '8px', margin: '0 5px' }}
//                                                                             onClick={() => handleOpenViewModal(ad._id)}
//                                                                         >
//                                                                             <i className="bi bi-eye" style={{ fontSize: '15px' }}></i> View
//                                                                         </Button>
//                                                                     )}
//                                                                     {(addAccess?.includes("AdvertisementMgt:update") || email === "contact@xpansecafe.com") && (
//                                                                         <Button
//                                                                             variant="light"
//                                                                             title="Edit"
//                                                                             size='sm'
//                                                                             className='text-primary'
//                                                                             style={{ padding: '8px', margin: '0 5px' }}
//                                                                             onClick={() => handleOpenEditModal(ad)}
//                                                                         >
//                                                                             <i className="bi bi-pencil" style={{ fontSize: '15px' }}></i> Edit
//                                                                         </Button>
//                                                                     )}
//                                                                     {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
//                                                                         <Button
//                                                                             variant="light"
//                                                                             title="Delete"
//                                                                             className='text-danger'
//                                                                             onClick={() => handleOpenDeleteModal(ad._id)}
//                                                                             style={{ padding: '8px', margin: '0 5px' }}
//                                                                         >
//                                                                             <i className="bi bi-trash" style={{ fontSize: '15px' }}></i> Delete
//                                                                         </Button>
//                                                                     )}
//                                                                 </div>
//                                                             </Card>
//                                                         </Col>
//                                                     ))}
//                                                     <Col lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                                 transition: 'transform 0.2s, box-shadow 0.2s',
//                                                                 cursor: 'pointer',
//                                                             }}
//                                                             onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
//                                                             onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 <Image
//                                                                     onClick={() => openUpdateImageModal(bottomImageAdd)}
//                                                                     src={bottomImageAdd?.adImagePath}
//                                                                     alt="ad-pic"
//                                                                     fluid
//                                                                     style={{
//                                                                         borderRadius: '8px',
//                                                                         maxHeight: '200px',
//                                                                         objectFit: 'cover',
//                                                                     }}
//                                                                 />
//                                                                 <h5
//                                                                     className="mt-3"
//                                                                     style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
//                                                                 >
//                                                                     {bottomImageAdd?.title?.toUpperCase()}
//                                                                 </h5>
//                                                             </Card.Body>
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {(addAccess?.includes("AdvertisementMgt:update") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="Edit"
//                                                                         size='sm'
//                                                                         className='text-primary'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenEditModal(bottomImageAdd)}
//                                                                     >
//                                                                         <i className="bi bi-pencil" style={{ fontSize: '18px' }}></i> Edit
//                                                                     </Button>
//                                                                 )}
//                                                                 {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="Delete"
//                                                                         className='text-danger'
//                                                                         onClick={() => handleOpenDeleteModal(bottomImageAdd?._id)}
//                                                                         size='sm'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                     >
//                                                                         <i className="bi bi-trash" style={{ fontSize: '18px' }}></i> Delete
//                                                                     </Button>
//                                                                 )}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 </>
//                                             )}
//                                         </Row>
//                                     </Tab>
//                                 </Tabs>

//                             </Container>
//                         {/* </Col> */}
//                     </Row>

//                     {openAddModal ? (
//                         <Modal show={openAddModal} onHide={handleCloseAddModal} centered size="lg">
//                             <Modal.Header closeButton>
//                                 <Modal.Title className="fs-6 fw-semibold pt-1">
//                                     ADD ADVERTISEMENT
//                                 </Modal.Title>
//                             </Modal.Header>
//                             <Form onSubmit={addAdvertisement}>
//                                 <Modal.Body>
//                                     <Row>
//                                     <Col>
//                                         <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">
//                                             Title <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Form.Control
//                                             type="text"
//                                             placeholder="Title"
//                                             name="title"
//                                             value={inputData.title}
//                                             onChange={handleInputChange}
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     <Col>
//                                         <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">
//                                             Select Type <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Form.Select
//                                             size="sm"
//                                             onChange={handleInputChange}
//                                             value={inputData?.type}
//                                             name="type"
//                                         >
//                                             <option value="">Select Type</option>
//                                             <option value="CLICKABLE">CLICKABLE</option>
//                                             <option value="NON-CLICKABLE">NON-CLICKABLE</option>
//                                         </Form.Select>
//                                         </Form.Group>
//                                     </Col>
//                                     </Row>
                        
//                                     <Row>
//                                     <Col>
//                                         <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">
//                                             Sequence No. <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Form.Control
//                                             type="number"
//                                             placeholder="Sequence No."
//                                             name="sequenceNo"
//                                             value={inputData?.sequenceNo}
//                                             onChange={handleInputChange}
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     {inputData?.type === "NON-CLICKABLE" ? (
//                                         <>
//                                         <Col>
//                                             <Form.Group className="mb-3">
//                                             <Form.Label className="fw-semibold">Top Image</Form.Label>
//                                             <Form.Select
//                                                 size="sm"
//                                                 onChange={handleInputChange}
//                                                 name="isTopImage"
//                                                 value={inputData?.isTopImage}
//                                             >
//                                                 <option value="" disabled>Is it Top Image</option>
//                                                 <option value="true">YES</option>
//                                                 <option value="false">NO</option>
//                                             </Form.Select>
//                                             </Form.Group>
//                                         </Col>
//                                         <Col>
//                                             <Form.Group className="mb-3">
//                                             <Form.Label className="fw-semibold">Bottom Image</Form.Label>
//                                             <Form.Select
//                                                 size="sm"
//                                                 onChange={handleInputChange}
//                                                 name="isBottomImage"
//                                                 value={inputData?.isBottomImage}
//                                             >
//                                                 <option value="" disabled>Is It Bottom Image</option>
//                                                 <option value="true">YES</option>
//                                                 <option value="false">NO</option>
//                                             </Form.Select>
//                                             </Form.Group>
//                                         </Col>
//                                         </>
//                                     ) : (
//                                         <Col>
//                                         <Form.Group className="mb-3">
//                                             <Form.Label className="fw-semibold">
//                                             Select Product <span className="text-danger">*</span>
//                                             </Form.Label>
//                                             <Select
//                                             options={productsList.map((rm) => ({
//                                                 value: rm._id,
//                                                 label: rm.name,
//                                             }))}
//                                             value={
//                                                 inputData?.product
//                                                 ? productsList
//                                                     .map((rm) => ({ value: rm._id, label: rm.name }))
//                                                     .find((option) => option.value === inputData.product)
//                                                 : null
//                                             }
//                                             onChange={(selectedOption) => {
//                                                 if (selectedOption) {
//                                                 handleInputChange({ target: { name: 'product', value: selectedOption.value } });
//                                                 } else {
//                                                 handleInputChange({ target: { name: 'product', value: '' } });
//                                                 }
//                                             }}
//                                             classNamePrefix="react-select"
//                                             isClearable
//                                             placeholder="Select Product"
//                                             />
//                                         </Form.Group>
//                                         </Col>
//                                     )}
//                                     </Row>
                        
//                                     <Row className="mb-2">
//                                     <Col md="3">
//                                         <Form.Group>
//                                         <Form.Label className="fw-semibold">Validity Start Date</Form.Label>
//                                         <DatePicker
//                                             selected={fromDate}
//                                             onChange={handleFromDateChange}
//                                             placeholderText="Start Date"
//                                             className="form-control"
//                                             isClearable
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     <Col md="3">
//                                         <Form.Group>
//                                         <Form.Label className="fw-semibold">Validity End Date</Form.Label>
//                                         <DatePicker
//                                             selected={toDate}
//                                             onChange={handleToDateChange}
//                                             placeholderText="End Date"
//                                             className="form-control"
//                                             isClearable
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     <Col md="6">
//                                         <Form.Group>
//                                         <Form.Label className="fw-semibold">Select Excluded Outlets</Form.Label>
//                                         <Select
//                                             isMulti
//                                             value={selectedExcludedOutlets}
//                                             onChange={handleSelectChange}
//                                             options={outletData}
//                                             placeholder="Select Excluded Outlets"
//                                             closeMenuOnSelect={false}
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     </Row>
                        
//                                     <Row>
//                                     <Col md="6">
//                                         <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">Add Link</Form.Label>
//                                         <Form.Control
//                                             type="text"
//                                             placeholder="Add Link"
//                                             name="link"
//                                             value={inputData.link}
//                                             disabled={inputData.type === "CLICKABLE"}
//                                             onChange={handleInputChange}
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     <Col md="6">
//                                         <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">
//                                             Choose File <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Form.Control
//                                             type="file"
//                                             onChange={handleImageChange}
//                                             id="imageInput"
//                                         />
//                                         <p className="text-danger" style={{ fontSize: '13px' }}>Choose an image with 1920x1080 pixels</p>
//                                         </Form.Group>
//                                     </Col>
//                                     </Row>
//                                 </Modal.Body>
//                                 <Modal.Footer>
//                                     <Button variant="primary" type="submit" disabled={isLoading}>
//                                     {isLoading ? <Spinner size='sm' /> : 'ADD ADVERTISEMENT'}
//                                     </Button>
//                                 </Modal.Footer>
//                             </Form>
//                         </Modal>
//                     ) : null}

//                     {openEditModal ? (
//                         <Modal
//                             show={openEditModal}
//                             onHide={() => setOpenEditModal(false)}
//                             centered
//                             size="lg"
//                             aria-labelledby="VerticallyCenteredExample"
//                         >
//                             <Modal.Header closeButton>
//                                 <Modal.Title id="VerticallyCenteredExample" className="fs-6">
//                                     EDIT ADVERTISEMENT
//                                 </Modal.Title>
//                             </Modal.Header>
//                             <Form onSubmit={handleEditSubmit}>
//                                 <Modal.Body>
//                                     {/* Title, Type, and Sequence Number */}
//                                     <Row>
//                                         <Col>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label className="fw-semibold">
//                                                     Title <span className="text-danger">*</span>
//                                                 </Form.Label>
//                                                 <Form.Control
//                                                     type="text"
//                                                     placeholder="Title"
//                                                     name="title"
//                                                     value={editedData?.title || ""}
//                                                     onChange={handleEditChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label className="fw-semibold">
//                                                     Select Type <span className="text-danger">*</span>
//                                                 </Form.Label>
//                                                 <Form.Select
//                                                     onChange={handleEditChange}
//                                                     value={editedData?.type || ""}
//                                                     name="type"
//                                                 >
//                                                     <option value="">Select Type</option>
//                                                     <option value="CLICKABLE">CLICKABLE</option>
//                                                     <option value="NON-CLICKABLE">NON-CLICKABLE</option>
//                                                 </Form.Select>
//                                             </Form.Group>
//                                         </Col>
//                                         <Col>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label className="fw-semibold">
//                                                     Sequence No. <span className="text-danger">*</span>
//                                                 </Form.Label>
//                                                 <Form.Control
//                                                     type="text"
//                                                     placeholder="Sequence No."
//                                                     name="sequenceNo"
//                                                     value={editedData?.sequenceNo || ""}
//                                                     onChange={handleEditChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>

//                                     {/* Validity Start and End Date */}
//                                     <Row className="mb-2">
//                                         <Col>
//                                             <Form.Group>
//                                                 <Form.Label className="fw-semibold">
//                                                     Validity Start Date
//                                                 </Form.Label>
//                                                 <DatePicker
//                                                     selected={fromDate}
//                                                     onChange={handleFromDateChange}
//                                                     placeholderText="Start Date"
//                                                     className="form-control"
//                                                     isClearable
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col>
//                                             <Form.Group>
//                                                 <Form.Label className="fw-semibold">
//                                                     Validity End Date
//                                                 </Form.Label>
//                                                 <DatePicker
//                                                     selected={toDate}
//                                                     onChange={handleToDateChange}
//                                                     placeholderText="End Date"
//                                                     className="form-control"
//                                                     isClearable
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>

//                                     {/* Conditional Rendering for Link, Top Image, and Bottom Image */}
//                                     <Row>
//                                         {editedData?.isTopImage || editedData?.isBottomImage ? (
//                                             <>
//                                                 <Col>
//                                                     <Form.Group>
//                                                         <Form.Label className="fw-semibold">Add Link</Form.Label>
//                                                         <Form.Control
//                                                             type="text"
//                                                             placeholder="Add Link"
//                                                             name="link"
//                                                             value={editedData?.link || ""}
//                                                             disabled={editedData?.type === "NON-CLICKABLE"}
//                                                             onChange={handleEditChange}
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>
//                                                 <Col>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">
//                                                             Top Image <span className="text-danger">*</span>
//                                                         </Form.Label>
//                                                         <Form.Select
//                                                             onChange={handleEditChange}
//                                                             name="isTopImage"
//                                                             value={editedData?.isTopImage || ""}
//                                                         >
//                                                             <option value="">Select</option>
//                                                             <option value="true">YES</option>
//                                                             <option value="false">NO</option>
//                                                         </Form.Select>
//                                                     </Form.Group>
//                                                 </Col>
//                                                 <Col>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">
//                                                             Bottom Image <span className="text-danger">*</span>
//                                                         </Form.Label>
//                                                         <Form.Select
//                                                             onChange={handleEditChange}
//                                                             name="isBottomImage"
//                                                             value={editedData?.isBottomImage || ""}
//                                                         >
//                                                             <option value="">Select</option>
//                                                             <option value="true">YES</option>
//                                                             <option value="false">NO</option>
//                                                         </Form.Select>
//                                                     </Form.Group>
//                                                 </Col>
//                                             </>
//                                         ) : (
//                                             <Col>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">
//                                                         Select Product <span className="text-danger">*</span>
//                                                     </Form.Label>
//                                                     <Select
//                                                         options={productsList.map((rm) => ({
//                                                             value: rm._id,
//                                                             label: rm.name,
//                                                         }))}
//                                                         value={
//                                                             editedData?.product
//                                                                 ? productsList
//                                                                     .map((rm) => ({ value: rm._id, label: rm.name }))
//                                                                     .find((option) => option.value === editedData?.product)
//                                                                 : null
//                                                         }
//                                                         onChange={(selectedOption) => {
//                                                             handleEditChange({
//                                                                 target: {
//                                                                     name: 'product',
//                                                                     value: selectedOption ? selectedOption.value : "",
//                                                                 },
//                                                             });
//                                                         }}
//                                                         classNamePrefix="react-select"
//                                                         isDisabled={editedData?.type === "NON-CLICKABLE"}
//                                                         isClearable
//                                                         placeholder="Select Product"
//                                                     />
//                                                 </Form.Group>
//                                             </Col>
//                                         )}
//                                     </Row>

//                                     {/* Excluded Outlets */}
//                                     <Row className="mb-3">
//                                         <Col>
//                                             <Form.Group>
//                                                 <Form.Label className="fw-semibold">
//                                                     Select Excluded Outlets
//                                                 </Form.Label>
//                                                 <Select
//                                                     isMulti
//                                                     value={selectedExcludedOutlets}
//                                                     onChange={handleEditSelectChange}
//                                                     options={outletData}
//                                                     styles={customStyles}
//                                                     placeholder="Select Excluded Outlets"
//                                                     closeMenuOnSelect={false}
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>
//                                 </Modal.Body>

//                                 {/* Footer with Save Button */}
//                                 <Modal.Footer>
//                                     <Button variant="primary" type="submit" disabled={isLoading}>
//                                         {isLoading ? <Spinner size="sm" /> : 'SAVE CHANGES'}
//                                     </Button>
//                                 </Modal.Footer>
//                             </Form>
//                         </Modal>
//                     ) : null}

//                     {openViewModal ? (
//                         <Modal
//                             show={openViewModal}
//                             onHide={() => setOpenViewModal(false)}
//                             centered
//                             size="lg"
//                             aria-labelledby="VerticallyCenteredExample"
//                         >
//                             <Modal.Header closeButton>
//                                 <Modal.Title id="VerticallyCenteredExample" className="fs-6">
//                                     VIEW ADVERTISEMENT DETAILS
//                                 </Modal.Title>
//                             </Modal.Header>
//                             <Modal.Body>
//                                 <div>
//                                     <h5 className="text-center">
//                                         {singleAdData?.title && singleAdData.title.toUpperCase()}
//                                     </h5>
//                                 </div>
//                                 <hr />
//                                 <div className="d-flex" style={{ justifyContent: 'space-between' }}>
//                                     {singleAdData?.validityStartDate && singleAdData?.validityEndDate ? (
//                                         <>
//                                             <span className="fw-semibold">
//                                                 Validity Starting From: 
//                                                 <span>
//                                                     {new Date(singleAdData?.validityStartDate).toLocaleDateString('en-GB', {
//                                                         year: 'numeric',
//                                                         month: 'numeric',
//                                                         day: 'numeric',
//                                                     })}
//                                                 </span>
//                                             </span>
//                                             <span className="fw-semibold">
//                                                 Validity Ending On: 
//                                                 <span>
//                                                     {new Date(singleAdData?.validityEndDate).toLocaleDateString('en-GB', {
//                                                         year: 'numeric',
//                                                         month: 'numeric',
//                                                         day: 'numeric',
//                                                         timeZone: 'UTC', // Force UTC timezone
//                                                     })}
//                                                 </span>
//                                             </span>
//                                         </>
//                                     ) : (
//                                         <span className="fw-semibold text-success">NO VALIDITY FOR THIS ADVERTISEMENT</span>
//                                     )}
//                                 </div>
//                                 <div className="d-flex justify-content-center">
//                                     <img
//                                         src={singleAdData?.adImagePath}
//                                         alt="ad-photo"
//                                         className="w-100"
//                                     />
//                                 </div>
//                                 <div className="mt-2">
//                                     <h6>
//                                         Excluded Outlets:{" "}
//                                         <span className="text-danger">
//                                             {singleAdData?.excludedOutlets && singleAdData?.excludedOutlets?.length > 0
//                                                 ? singleAdData?.excludedOutlets?.map(outlet => outlet?.name?.toLowerCase().trim()).join(', ')
//                                                 : "No outlets excluded."}
//                                         </span>
//                                     </h6>
//                                 </div>
//                                 {activeTab === "CLICKABLE" ? (
//                                     <div className="mt-3">
//                                         <Table bordered>
//                                             <thead>
//                                                 <tr>
//                                                     <th className="text-center" colSpan={6}>
//                                                         PRODUCT INFORMATION
//                                                     </th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 <tr>
//                                                     <th className="text-center">IMAGE</th>
//                                                     <th className="text-center">NAME</th>
//                                                     <th className="text-center">DESCRIPTION</th>
//                                                     <th className="text-center">HSN</th>
//                                                     <th className="text-center">MRP</th>
//                                                     <th className="text-center">OFFER PRICE</th>
//                                                 </tr>
//                                                 <tr>
//                                                     <td className="text-center">
//                                                         <img
//                                                             src={singleAdData?.product?.displayImage}
//                                                             alt="product-image"
//                                                             style={{ width: "100px", height: "100px" }}
//                                                         />
//                                                     </td>
//                                                     <td className="text-center">
//                                                         {singleAdData?.product?.name}
//                                                     </td>
//                                                     <td className="text-center">
//                                                         {singleAdData?.product?.description}
//                                                     </td>
//                                                     <td className="text-center">
//                                                         {singleAdData?.product?.hsn}
//                                                     </td>
//                                                     <td className="text-center">
//                                                         {singleAdData?.product?.mrp}
//                                                     </td>
//                                                     <td className="text-center">
//                                                         {singleAdData?.product?.offerPrice} Rs
//                                                     </td>
//                                                 </tr>
//                                             </tbody>
//                                         </Table>
//                                     </div>
//                                 ) : null}
//                             </Modal.Body>
//                             <Modal.Footer>
//                                 <Button
//                                     variant="warning"
//                                     onClick={() => setOpenViewModal(false)}
//                                     style={{ borderRadius: "18px" }}
//                                 >
//                                     CLOSE
//                                 </Button>
//                             </Modal.Footer>
//                         </Modal>
//                     ) : null}

//                     {openDeleteModal && (
//                         <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
//                             <Modal.Header closeButton>
//                                 <Modal.Title>Confirm Delete</Modal.Title>
//                             </Modal.Header>
//                             <Modal.Body>
//                                 Are you sure you want to delete this Advertisement? This action cannot be undone.
//                             </Modal.Body>
//                             <Modal.Footer>
//                                 <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
//                                     Cancel
//                                 </Button>
//                                 <Button variant="danger" onClick={deleteAdvertisement}>
//                                     { isDeleteBtnLoading ?
//                                         <Spinner
//                                             as="span"
//                                             animation="border"
//                                             size="sm"
//                                             role="status"
//                                             aria-hidden="true"
//                                         /> :
//                                         "Delete Advertisement"                                
//                                     }
//                                 </Button>
//                             </Modal.Footer>
//                         </Modal>
//                     )}

//                     {isOpenUpdateImageModal && (
//                         <Modal
//                             show={isOpenUpdateImageModal}
//                             onHide={() => setIsOpenUpdateImageModal(false)}
//                             centered
//                             aria-labelledby="VerticallyCenteredExample"
//                         >
//                             <Modal.Header closeButton>
//                                 <Modal.Title id="VerticallyCenteredExample" className="fs-6">
//                                     UPDATE ADVERTISEMENT IMAGE
//                                 </Modal.Title>
//                             </Modal.Header>
//                             <Form >
//                                 <Modal.Body>
//                                     <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">
//                                             Choose File <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Form.Control
//                                             type="file"
//                                             onChange={handleEditImageChange}
//                                             id="imageInput"
//                                         />
//                                     </Form.Group>
//                                 </Modal.Body>
//                                 <Modal.Footer>
//                                     <Button variant="primary"  onClick={handleEditImage} disabled={isImageUpdating}>
//                                         {isImageUpdating ? <Spinner size='sm' /> : 'SAVE CHANGES' }
//                                     </Button>
//                                 </Modal.Footer>
//                             </Form>
//                         </Modal>
//                     )}

//                 </div>
//             </div>
//             {/* Add CSS Animation */}
//             <style>
//                 {`
//                     @keyframes skeletonPulse {
//                         0% {
//                             background-position: 200% 0;
//                         }
//                         100% {
//                             background-position: -200% 0;
//                         }
//                     }
                    
//                     .skeleton-card {
//                         pointer-events: none;
//                     }
//                 `}
//             </style>
//         </React.Fragment>
//     )
// }

// export default AdvertisementMgt




// New Design
import React, { useEffect, useMemo, useRef, useState } from 'react'
import Header from '../../layouts/Header';
import {
    Button, Col, Dropdown, Form, Image, Modal, Offcanvas, Row, Spinner, Table
} from 'react-bootstrap';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from 'react-redux';

// ======================= helpers =======================

const PAGE_SIZE = 4;
const MAX_IMAGE_MB = 5;
const TOAST = { position: "top-right", autoClose: 3000, theme: "colored" };

const getAdStatus = (ad) => {
    const now = new Date();
    const start = ad?.validityStartDate ? new Date(ad.validityStartDate) : null;
    const end = ad?.validityEndDate ? new Date(ad.validityEndDate) : null;
    if (start && now < start) return "SCHEDULED";
    if (end && now > end) return "EXPIRED";
    return "ACTIVE";
};

const STATUS_META = {
    ACTIVE: { bg: "#E7F7EE", color: "#1F9254", label: "Active" },
    EXPIRED: { bg: "#FDEBEC", color: "#D93025", label: "Expired" },
    SCHEDULED: { bg: "#FFF4E5", color: "#B7791F", label: "Scheduled" },
};

const CATEGORY_META = {
    CLICKABLE: { label: "Clickable", bg: "#EAF1FF", color: "#2A5CD9" },
    NON_CLICKABLE: { label: "Non Clickable", bg: "#F1F2F4", color: "#5F6672" },
    TOP_BANNER: { label: "Top Banner", bg: "#F3EBFF", color: "#7A3FD9" },
    BOTTOM_BANNER: { label: "Bottom Banner", bg: "#FFEFF5", color: "#C23574" },
};

const StatusBadge = ({ status }) => {
    const m = STATUS_META[status] || STATUS_META.ACTIVE;
    return (
        <span className="adm-status" style={{ background: m.bg, color: m.color }}>
            <span className="adm-dot" style={{ background: m.color }} />
            {m.label}
        </span>
    );
};

const CategoryBadge = ({ category }) => {
    const m = CATEGORY_META[category] || CATEGORY_META.CLICKABLE;
    return <span className="adm-type" style={{ background: m.bg, color: m.color }}>{m.label}</span>;
};

const fmtDate = (d) => d
    ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
    : null;

const toYMD = (d) => d
    ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0]
    : null;

const getErrMsg = (error) => {
    const d = error?.response?.data;
    return d?.error?.message
        || (typeof d?.error === "string" ? d.error : null)
        || d?.data?.message
        || d?.message
        || "Something went wrong. Please try again.";
};

const dayDiff = (ms) => Math.max(1, Math.ceil(Math.abs(ms) / 86400000));

const validityHint = (ad) => {
    const status = getAdStatus(ad);
    const now = new Date();
    if (status === "SCHEDULED") return `Starts in ${dayDiff(new Date(ad.validityStartDate) - now)} day(s)`;
    if (status === "EXPIRED") return `Expired ${dayDiff(now - new Date(ad.validityEndDate))} day(s) ago`;
    if (ad.validityEndDate) return `Ends in ${dayDiff(new Date(ad.validityEndDate) - now)} day(s)`;
    return null;
};

const selectStyles = {
    control: (p, s) => ({
        ...p, minHeight: 44, borderRadius: 10, fontSize: 14,
        borderColor: s.isFocused ? "#4F46E5" : "#E3E6EC",
        boxShadow: s.isFocused ? "0 0 0 3px rgba(79,70,229,.12)" : "none",
        "&:hover": { borderColor: s.isFocused ? "#4F46E5" : "#cfd4dc" },
    }),
    placeholder: (p) => ({ ...p, color: "#8A93A3" }),
    menuPortal: (p) => ({ ...p, zIndex: 2100 }),
    multiValue: (p) => ({ ...p, background: "#EEF0FF", borderRadius: 6 }),
    multiValueLabel: (p) => ({ ...p, color: "#3B3FB8", fontWeight: 600 }),
};

// ======================= image dropzone =======================

const ImageDropzone = ({ file, existingUrl, onChange, error }) => {
    const inputRef = useRef(null);
    const [drag, setDrag] = useState(false);
    const [preview, setPreview] = useState(null);
    const [warn, setWarn] = useState("");
    const [localError, setLocalError] = useState("");

    useEffect(() => {
        if (!file) { setPreview(null); setWarn(""); return; }
        const url = URL.createObjectURL(file);
        setPreview(url);
        const img = new window.Image();
        img.onload = () => setWarn(
            img.width === 1920 && img.height === 1080 ? ""
                : `This image is ${img.width}×${img.height}px. 1920×1080px is recommended.`
        );
        img.src = url;
        return () => URL.revokeObjectURL(url);
    }, [file]);

    const pick = (f) => {
        if (!f) return;
        if (!f.type.startsWith("image/")) { setLocalError("Choose an image file (PNG, JPG or WEBP)."); return; }
        if (f.size > MAX_IMAGE_MB * 1024 * 1024) { setLocalError(`Image must be smaller than ${MAX_IMAGE_MB} MB.`); return; }
        setLocalError("");
        onChange(f);
    };

    const shown = preview || existingUrl;
    const msg = localError || error;

    return (
        <div>
            <input ref={inputRef} type="file" accept="image/*" hidden
                onChange={(e) => { pick(e.target.files[0]); e.target.value = ""; }} />
            {shown ? (
                <div className="adm-drop-preview">
                    <img src={shown} alt="Advertisement preview" />
                    <div className="adm-drop-actions">
                        <Button size="sm" variant="light" onClick={() => inputRef.current.click()}>
                            <i className="bi bi-arrow-repeat me-1" /> Replace
                        </Button>
                        {file && (
                            <Button size="sm" variant="light" onClick={() => { setLocalError(""); onChange(null); }}>
                                <i className="bi bi-x-lg me-1" /> Remove
                            </Button>
                        )}
                    </div>
                </div>
            ) : (
                <div
                    className={`adm-drop ${drag ? "is-drag" : ""} ${msg ? "is-error" : ""}`}
                    role="button" tabIndex={0}
                    onClick={() => inputRef.current.click()}
                    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && inputRef.current.click()}
                    onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
                    onDragLeave={() => setDrag(false)}
                    onDrop={(e) => { e.preventDefault(); setDrag(false); pick(e.dataTransfer.files[0]); }}
                >
                    <i className="bi bi-cloud-arrow-up" />
                    <div className="fw-semibold">Drag and drop an image, or <span className="text-primary">browse</span></div>
                    <small className="text-muted">PNG, JPG or WEBP, up to {MAX_IMAGE_MB} MB, 1920×1080px recommended</small>
                </div>
            )}
            {file && <small className="text-muted d-block mt-1">{file.name} ({(file.size / 1024).toFixed(0)} KB)</small>}
            {warn && <small className="d-block mt-1" style={{ color: "#B7791F" }}><i className="bi bi-exclamation-triangle me-1" />{warn}</small>}
            {msg && <small className="d-block mt-1 text-danger">{msg}</small>}
        </div>
    );
};

// ======================= add / edit modal =======================

const FieldError = ({ msg }) => (msg ? <div className="text-danger mt-1" style={{ fontSize: 12.5 }}>{msg}</div> : null);

const AdFormModal = ({ mode, initial, outletOptions, products, saving, onClose, onSave }) => {
    const isEdit = mode === "edit";
    const [form, setForm] = useState(initial.form);
    const [start, setStart] = useState(initial.start);
    const [end, setEnd] = useState(initial.end);
    const [excluded, setExcluded] = useState(initial.excluded);
    const [file, setFile] = useState(null);
    const [errors, setErrors] = useState({});

    const isClickable = form.type === "CLICKABLE";
    const productOptions = useMemo(() => products.map((p) => ({ value: p._id, label: p.name })), [products]);

    const set = (k, v) => {
        setForm((p) => ({ ...p, [k]: v }));
        setErrors((p) => ({ ...p, [k]: undefined }));
    };

    const validate = () => {
        const e = {};
        if (!form.title.trim()) e.title = "Enter a title.";
        if (form.sequenceNo === "" || isNaN(Number(form.sequenceNo)) || Number(form.sequenceNo) < 0) e.sequenceNo = "Enter a sequence number.";
        if (isClickable && !form.product) e.product = "Select the product this ad opens.";
        if ((start && !end) || (!start && end)) e.dates = "Select both a start date and an end date.";
        else if (start && end && end < start) e.dates = "End date can't be before the start date.";
        if (!isEdit && !file) e.file = "Upload an image for this advertisement.";
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const handleSubmit = (ev) => {
        ev.preventDefault();
        if (!validate()) return;

        const fd = new FormData();
        if (isEdit) fd.append("_id", initial.id);
        fd.append("title", form.title.trim());
        fd.append("type", form.type);
        fd.append("sequenceNo", form.sequenceNo);

        const s = toYMD(start);
        const en = toYMD(end);
        if (isEdit) {
            fd.append("validityStartDate", s);
            fd.append("validityEndDate", en);
        } else {
            if (s) fd.append("validityStartDate", s);
            if (en) fd.append("validityEndDate", en);
        }

        if (isClickable) {
            if (form.product) fd.append("product", form.product);
        } else {
            fd.append("isTopImage", String(form.placement === "top"));
            fd.append("isBottomImage", String(form.placement === "bottom"));
            // if (form.link.trim()) fd.append("link", form.link.trim());
        }

        const ids = excluded.map((o) => o.value);
        if (isEdit && !ids.length) fd.append("excludedOutlets", null);
        else ids.forEach((id, i) => fd.append(`excludedOutlets[${i}]`, id));

        if (file) fd.append("adImage", file);
        onSave(fd);
    };

    return (
        <Modal show onHide={saving ? undefined : onClose} centered size="lg" scrollable backdrop="static" dialogClassName="adm-ad-modal">
            <Modal.Header closeButton className="border-0 pb-0">
                <div>
                    <Modal.Title className="fs-5 fw-bold">{isEdit ? "Edit advertisement" : "Add advertisement"}</Modal.Title>
                    <div className="text-muted" style={{ fontSize: 13 }}>
                        {isEdit ? "Update the details, schedule or image." : "Fill in the details, then upload the creative."}
                    </div>
                </div>
            </Modal.Header>

            <Form noValidate onSubmit={handleSubmit}>
                <Modal.Body className="pt-3">
                    {/* ---- Details ---- */}
                    <div className="adm-section">Details</div>
                    <Row className="g-3 mb-4">
                        <Col md={8}>
                            <Form.Label className="adm-label">Title <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                className="adm-input" placeholder="e.g. Diwali combo offer"
                                value={form.title} isInvalid={!!errors.title}
                                onChange={(e) => set("title", e.target.value)} autoFocus
                            />
                            <FieldError msg={errors.title} />
                        </Col>
                        <Col md={4}>
                            <Form.Label className="adm-label">Sequence no. <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                className="adm-input" type="number" min={0} placeholder="1"
                                value={form.sequenceNo} isInvalid={!!errors.sequenceNo}
                                onChange={(e) => set("sequenceNo", e.target.value)}
                            />
                            <FieldError msg={errors.sequenceNo} />
                        </Col>

                        <Col xs={12}>
                            <Form.Label className="adm-label">Type <span className="text-danger">*</span></Form.Label>
                            <div className="adm-choices" role="radiogroup">
                                {[
                                    { v: "CLICKABLE", icon: "bi-hand-index-thumb", t: "Clickable", d: "Opens a product when tapped" },
                                    { v: "NON-CLICKABLE", icon: "bi-image", t: "Non clickable", d: "Display-only banner or image" },
                                ].map((o) => (
                                    <button type="button" key={o.v} role="radio" aria-checked={form.type === o.v}
                                        className={`adm-choice ${form.type === o.v ? "is-active" : ""}`}
                                        onClick={() => set("type", o.v)}>
                                        <i className={`bi ${o.icon}`} />
                                        <span><b>{o.t}</b><small>{o.d}</small></span>
                                    </button>
                                ))}
                            </div>
                        </Col>

                        {isClickable ? (
                            <Col xs={12}>
                                <Form.Label className="adm-label">Product <span className="text-danger">*</span></Form.Label>
                                <Select
                                    styles={selectStyles} menuPortalTarget={document.body}
                                    options={productOptions} isClearable placeholder="Search and select a product"
                                    value={productOptions.find((o) => o.value === form.product) || null}
                                    onChange={(o) => set("product", o ? o.value : "")}
                                />
                                <FieldError msg={errors.product} />
                            </Col>
                        ) : (
                            <>
                                <Col xs={12}>
                                    <Form.Label className="adm-label">Placement</Form.Label>
                                    <div className="adm-segment">
                                        {[
                                            { v: "standard", l: "Standard" },
                                            { v: "top", l: "Top banner" },
                                            { v: "bottom", l: "Bottom banner" },
                                        ].map((o) => (
                                            <button type="button" key={o.v}
                                                className={form.placement === o.v ? "is-active" : ""}
                                                onClick={() => set("placement", o.v)}>{o.l}</button>
                                        ))}
                                    </div>
                                    <small className="text-muted">Only one bottom banner is shown at a time.</small>
                                </Col>
                                {/* <Col xs={12}>
                                    <Form.Label className="adm-label">Link <span className="text-muted fw-normal">(optional)</span></Form.Label>
                                    <Form.Control
                                        className="adm-input" placeholder="https://"
                                        value={form.link} isInvalid={!!errors.link}
                                        onChange={(e) => set("link", e.target.value)}
                                    />
                                    <FieldError msg={errors.link} />
                                </Col> */}
                            </>
                        )}
                    </Row>

                    {/* ---- Schedule & reach ---- */}
                    <div className="adm-section">Schedule and reach</div>
                    <Row className="g-3 mb-4">
                        <Col md={6}>
                            <Form.Label className="adm-label">Start date</Form.Label>
                            <DatePicker
                                selected={start} onChange={(d) => { setStart(d); setErrors((p) => ({ ...p, dates: undefined })); }}
                                selectsStart startDate={start} endDate={end}
                                placeholderText="Select start date" dateFormat="dd MMM yyyy"
                                className={`form-control adm-input ${errors.dates ? "is-invalid" : ""}`}
                                wrapperClassName="w-100" isClearable
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Label className="adm-label">End date</Form.Label>
                            <DatePicker
                                selected={end} onChange={(d) => { setEnd(d); setErrors((p) => ({ ...p, dates: undefined })); }}
                                selectsEnd startDate={start} endDate={end} minDate={start}
                                placeholderText="Select end date" dateFormat="dd MMM yyyy"
                                className={`form-control adm-input ${errors.dates ? "is-invalid" : ""}`}
                                wrapperClassName="w-100" isClearable
                            />
                        </Col>
                        <Col xs={12} className="mt-1">
                            {errors.dates
                                ? <FieldError msg={errors.dates} />
                                : <small className="text-muted">Leave both dates empty for an ad with no expiry.</small>}
                        </Col>
                        <Col xs={12}>
                            <Form.Label className="adm-label">Excluded outlets</Form.Label>
                            <Select
                                isMulti styles={selectStyles} menuPortalTarget={document.body}
                                options={outletOptions} value={excluded} onChange={(v) => setExcluded(v || [])}
                                placeholder="Shown at all outlets" closeMenuOnSelect={false}
                            />
                            <small className="text-muted">
                                {excluded.length ? `Hidden at ${excluded.length} outlet(s).` : "Leave empty to show this ad at every outlet."}
                            </small>
                        </Col>
                    </Row>

                    {/* ---- Creative ---- */}
                    <div className="adm-section">Image</div>
                    <ImageDropzone
                        file={file} existingUrl={isEdit ? initial.imageUrl : null}
                        error={errors.file}
                        onChange={(f) => { setFile(f); setErrors((p) => ({ ...p, file: undefined })); }}
                    />
                </Modal.Body>

                <Modal.Footer className="border-0 pt-0">
                    <Button variant="light" className="border fw-semibold" onClick={onClose} disabled={saving}>Cancel</Button>
                    <Button type="submit" className="adm-primary fw-semibold" disabled={saving}>
                        {saving ? <Spinner size="sm" /> : isEdit ? "Save changes" : "Add advertisement"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

// ======================= change image modal =======================

const ChangeImageModal = ({ ad, saving, onClose, onSave }) => {
    const [file, setFile] = useState(null);
    const [error, setError] = useState("");
    const submit = () => {
        if (!file) { setError("Choose an image to upload."); return; }
        onSave(file);
    };
    return (
        <Modal show onHide={saving ? undefined : onClose} centered backdrop="static">
            <Modal.Header closeButton className="border-0 pb-0">
                <div>
                    <Modal.Title className="fs-5 fw-bold">Change image</Modal.Title>
                    <div className="text-muted" style={{ fontSize: 13 }}>{ad?.title}</div>
                </div>
            </Modal.Header>
            <Modal.Body>
                <ImageDropzone file={file} existingUrl={ad?.adImagePath} error={error}
                    onChange={(f) => { setFile(f); setError(""); }} />
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0">
                <Button variant="light" className="border fw-semibold" onClick={onClose} disabled={saving}>Cancel</Button>
                <Button className="adm-primary fw-semibold" onClick={submit} disabled={saving}>
                    {saving ? <Spinner size="sm" /> : "Save image"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

// ======================= view drawer =======================

const InfoRow = ({ icon, label, children }) => (
    <div className="adm-info">
        <div className="adm-info-icon"><i className={`bi ${icon}`} /></div>
        <div className="flex-grow-1">
            <div className="adm-info-label">{label}</div>
            <div className="adm-info-value">{children}</div>
        </div>
    </div>
);

const ViewDrawer = ({ ad, loading, can, onClose, onEdit, onImage, onDelete }) => {
    const last = useRef(ad);
    if (ad) last.current = ad;
    const a = ad || last.current;
    if (!a) return null;

    const status = getAdStatus(a);
    const hint = validityHint(a);
    const hasValidity = a.validityStartDate && a.validityEndDate;
    const product = a.product && typeof a.product === "object" ? a.product : null;

    return (
        <Offcanvas show={!!ad} onHide={onClose} placement="end" className="adm-drawer">
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title className="fs-6 fw-bold">Advertisement details</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="p-0 d-flex flex-column">
                <div className="flex-grow-1 overflow-auto p-3">
                    <div className="adm-hero">
                        <img src={a.adImagePath} alt={a.title} />
                    </div>

                    <h5 className="fw-bold mt-3 mb-2" style={{ color: "#1B1F27" }}>{a.title}</h5>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                        <CategoryBadge category={a._category} />
                        <StatusBadge status={status} />
                    </div>

                    <div className="adm-info-card">
                        <InfoRow icon="bi-calendar-event" label="Validity">
                            {hasValidity ? `${fmtDate(a.validityStartDate)} – ${fmtDate(a.validityEndDate)}` : "No expiry"}
                            {hint && <div className="adm-hint">{hint}</div>}
                        </InfoRow>
                        <InfoRow icon="bi-sort-numeric-down" label="Sequence no.">{a.sequenceNo ?? "—"}</InfoRow>
                        <InfoRow icon="bi-shop" label="Outlets">
                            {a.excludedOutlets?.length ? (
                                <>
                                    <div className="mb-1 text-muted" style={{ fontSize: 12.5 }}>Hidden at {a.excludedOutlets.length} outlet(s)</div>
                                    <div className="d-flex flex-wrap gap-1">
                                        {a.excludedOutlets.map((o) => (
                                            <span key={o._id || o.name} className="adm-chip">{o.name}</span>
                                        ))}
                                    </div>
                                </>
                            ) : "Shown at all outlets"}
                        </InfoRow>
                        {/* {a.link && (
                            <InfoRow icon="bi-link-45deg" label="Link">
                                <a href={a.link} target="_blank" rel="noreferrer" className="text-break">{a.link}</a>
                            </InfoRow>
                        )} */}
                    </div>

                    {loading && !product && (
                        <div className="text-muted mt-3" style={{ fontSize: 13 }}><Spinner size="sm" className="me-2" />Loading product details…</div>
                    )}

                    {product && (
                        <>
                            <div className="adm-section mt-4">Linked product</div>
                            <div className="adm-product">
                                <img src={product.displayImage} alt={product.name} />
                                <div className="flex-grow-1">
                                    <div className="fw-semibold">{product.name}</div>
                                    {product.description && <div className="text-muted" style={{ fontSize: 12.5 }}>{product.description}</div>}
                                    <div className="d-flex align-items-center gap-2 mt-2">
                                        <span className="fw-bold" style={{ color: "#1F9254" }}>₹{product.offerPrice}</span>
                                        {product.mrp != null && product.mrp !== product.offerPrice && (
                                            <span className="text-muted text-decoration-line-through" style={{ fontSize: 13 }}>₹{product.mrp}</span>
                                        )}
                                        {product.hsn && <span className="ms-auto text-muted" style={{ fontSize: 12 }}>HSN {product.hsn}</span>}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <div className="adm-drawer-footer">
                    {can("update") && (
                        <Button className="adm-primary fw-semibold flex-fill" onClick={() => onEdit(a)}>
                            <i className="bi bi-pencil me-1" /> Edit
                        </Button>
                    )}
                    {can("update") && (
                        <Button variant="light" className="border fw-semibold" onClick={() => onImage(a)} title="Change image">
                            <i className="bi bi-image" />
                        </Button>
                    )}
                    {can("delete") && (
                        <Button variant="outline-danger" className="fw-semibold" onClick={() => onDelete(a)} title="Delete">
                            <i className="bi bi-trash" />
                        </Button>
                    )}
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

// ======================= sortable header =======================

const SortTh = ({ label, k, sort, onSort }) => {
    const active = sort.key === k;
    return (
        <th className="adm-sortable" onClick={() => onSort(k)}>
            {label}{" "}
            <i className={`bi ${active ? (sort.dir === "asc" ? "bi-caret-up-fill" : "bi-caret-down-fill") : "bi-arrow-down-up"}`}
                style={{ fontSize: 10, color: active ? "#4F46E5" : "#A4ABB8" }} />
        </th>
    );
};

// ======================= main =======================

const AdvertisementMgt = () => {
    const [, setSkin] = useState(localStorage.getItem('skin-mode') ? 'dark' : '');
    const { access } = useSelector((state) => state.login);
    const { loginEmail } = useSelector((state) => state.login);
    const email = loginEmail || localStorage.getItem("email");
    const [addAccess, setAddAccess] = useState([]);

    useEffect(() => {
        if (Array.isArray(access)) {
            setAddAccess(access?.filter((perm) => perm?.startsWith("AdvertisementMgt:")));
        }
    }, [access]);

    const hasPerm = (perm) => addAccess?.includes(`AdvertisementMgt:${perm}`) || email === "contact@xpansecafe.com";
    const accessToken = localStorage.getItem("authToken");
    const authHeaders = { Authorization: `Bearer ${accessToken}` };

    // ---------- data ----------
    const [listLoading, setListLoading] = useState(false);
    const [clickableAdvertisementData, setClickableAdvertisementData] = useState([]);
    const [nonClickableAdvertisementData, setNonClickableAdvertisementData] = useState([]);
    const [topImageAdd, setTopImageAdd] = useState([]);
    const [bottomImageAdd, setBottomImageAdd] = useState({});
    const [outlets, setOutlets] = useState([]);
    const [productsList, setProductsList] = useState([]);

    // ---------- ui state ----------
    const [activeTab, setActiveTab] = useState("ALL");
    const [searchText, setSearchText] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [outletFilter, setOutletFilter] = useState(null);
    const [sort, setSort] = useState({ key: null, dir: "asc" });
    const [page, setPage] = useState(1);
    const [isRefreshBtnLoading, setIsRefreshBtnLoading] = useState(false);

    // ---------- overlays ----------
    const [formState, setFormState] = useState(null);       // { mode: 'add' } | { mode: 'edit', ad }
    const [viewAd, setViewAd] = useState(null);
    const [singleAd, setSingleAd] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);
    const [deleteAd, setDeleteAd] = useState(null);
    const [imageAd, setImageAd] = useState(null);
    const [saving, setSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isImageUpdating, setIsImageUpdating] = useState(false);

    // ---------- API ----------

    const getAdvertisementList = async () => {
        setListLoading(true);
        try {
            const response = await axiosInstance.get("advertisement", { headers: authHeaders });
            if (response?.data?.status === true) {
                const ads = response?.data?.data?.advertisements;
                const totalNonClickable = ads?.nonClickableAdvertisements || [];
                setClickableAdvertisementData(ads?.clickableAdvertisements || []);
                setNonClickableAdvertisementData(totalNonClickable.filter(ad => ad.isTopImage === false && ad.isBottomImage === false));
                setTopImageAdd(totalNonClickable.filter(ad => ad.isTopImage === true));
                setBottomImageAdd(totalNonClickable.find(ad => ad.isBottomImage === true) || {});
            }
        } catch (error) {
            if (error.response?.data?.status === false) toast.error(getErrMsg(error), TOAST);
        } finally {
            setListLoading(false);
        }
    };

    const getOutlets = async () => {
        try {
            const response = await axiosInstance.get("outlet", { headers: authHeaders });
            if (response?.data?.status === true) {
                setOutlets(response?.data?.data?.outlets?.filter((o) => o?.status === "ACTIVE") || []);
            }
        } catch (error) {
            if (error.response?.data?.status === false) toast.error(getErrMsg(error), TOAST);
        }
    };

    const getProductsList = async () => {
        try {
            const response = await axiosInstance.get("product", { headers: authHeaders });
            if (response?.data?.status === true) setProductsList(response?.data?.data?.products || []);
        } catch (error) {
            if (error.response?.data?.status === false) toast.error(getErrMsg(error), TOAST);
        }
    };

    const getSingleAdvertisement = async (id) => {
        setDetailLoading(true);
        try {
            const response = await axiosInstance.get(`advertisement?_id=${id}`, { headers: authHeaders });
            if (response?.data?.status === true) setSingleAd(response?.data?.data?.advertisements);
        } catch (error) {
            if (error.response?.data?.status === false) toast.error(getErrMsg(error), TOAST);
        } finally {
            setDetailLoading(false);
        }
    };

    const handleRefresh = async () => {
        setIsRefreshBtnLoading(true);
        try {
            const response = await axiosInstance.get('advertisement/clear-advertisement-cache', { headers: authHeaders });
            if (response?.data?.status === true) toast.success(response?.data?.message, TOAST);
        } catch (error) {
            if (error?.response) toast.error(getErrMsg(error), TOAST);
        } finally {
            setIsRefreshBtnLoading(false);
        }
    };

    useEffect(() => {
        getAdvertisementList();
        getOutlets();
        getProductsList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ---------- derived lists ----------

    const allAds = useMemo(() => {
        const clickable = clickableAdvertisementData.map(ad => ({ ...ad, _category: 'CLICKABLE' }));
        const nonClickable = nonClickableAdvertisementData.map(ad => ({ ...ad, _category: 'NON_CLICKABLE' }));
        const top = topImageAdd.map(ad => ({ ...ad, _category: 'TOP_BANNER' }));
        const bottom = bottomImageAdd && bottomImageAdd._id ? [{ ...bottomImageAdd, _category: 'BOTTOM_BANNER' }] : [];
        return [...clickable, ...nonClickable, ...top, ...bottom];
    }, [clickableAdvertisementData, nonClickableAdvertisementData, topImageAdd, bottomImageAdd]);

    const counts = useMemo(() => {
        const c = { ALL: allAds.length, CLICKABLE: 0, NON_CLICKABLE: 0, TOP_BANNER: 0, BOTTOM_BANNER: 0 };
        const s = { ACTIVE: 0, EXPIRED: 0, SCHEDULED: 0 };
        let excluded = 0;
        allAds.forEach(ad => {
            c[ad._category] += 1;
            s[getAdStatus(ad)] += 1;
            if (ad.excludedOutlets?.length) excluded += 1;
        });
        return { ...c, ...s, INACTIVE: s.EXPIRED + s.SCHEDULED, EXCLUDED: excluded };
    }, [allAds]);

    const outletOptions = useMemo(
        () => outlets.map((o) => ({ value: o._id, label: o.city ? `${o.name} (${o.city})` : o.name })),
        [outlets]
    );

    const filteredAds = useMemo(() => {
        let list = allAds;
        if (activeTab !== "ALL") list = list.filter(ad => ad._category === activeTab);
        if (statusFilter === "INACTIVE") list = list.filter(ad => getAdStatus(ad) !== "ACTIVE");
        else if (statusFilter) list = list.filter(ad => getAdStatus(ad) === statusFilter);
        if (outletFilter) list = list.filter(ad => !(ad.excludedOutlets || []).some(o => o._id === outletFilter.value));
        if (searchText.trim()) {
            const q = searchText.toLowerCase();
            list = list.filter(ad => ad.title?.toLowerCase().includes(q) || ad.product?.name?.toLowerCase().includes(q));
        }
        if (sort.key) {
            const val = (ad) => {
                if (sort.key === "title") return (ad.title || "").toLowerCase();
                if (sort.key === "type") return ad._category;
                if (sort.key === "status") return getAdStatus(ad);
                return ad.validityStartDate ? new Date(ad.validityStartDate).getTime() : 0;
            };
            list = [...list].sort((a, b) => {
                const x = val(a), y = val(b);
                if (x === y) return 0;
                return (x > y ? 1 : -1) * (sort.dir === "asc" ? 1 : -1);
            });
        }
        return list;
    }, [allAds, activeTab, statusFilter, outletFilter, searchText, sort]);

    const totalPages = Math.max(1, Math.ceil(filteredAds.length / PAGE_SIZE));
    const pagedAds = filteredAds.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    useEffect(() => { setPage(1); }, [activeTab, statusFilter, outletFilter, searchText]);
    // keep the page valid after a delete or refresh leaves fewer pages than before
    useEffect(() => { if (page > totalPages) setPage(totalPages); }, [page, totalPages]);

    const pageNumbers = (() => {
        const max = 5;
        let s = Math.max(1, page - 2);
        const e = Math.min(totalPages, s + max - 1);
        s = Math.max(1, e - max + 1);
        return Array.from({ length: e - s + 1 }, (_, i) => s + i);
    })();

    const clearFilters = () => { setStatusFilter(""); setOutletFilter(null); setSearchText(""); setActiveTab("ALL"); setSort({ key: null, dir: "asc" }); };
    const toggleSort = (key) => setSort(s => s.key === key ? { key, dir: s.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" });

    // ---------- actions ----------

    const buildEditInitial = (ad) => {
        const typeRaw = ad?.type || (ad?._category === "CLICKABLE" ? "CLICKABLE" : "NON-CLICKABLE");
        const end = ad?.validityEndDate ? new Date(ad.validityEndDate) : null;
        if (end) end.setDate(end.getDate() - 1);
        return {
            id: ad._id,
            imageUrl: ad.adImagePath,
            form: {
                title: ad.title || "",
                type: /non/i.test(typeRaw) ? "NON-CLICKABLE" : "CLICKABLE",
                sequenceNo: ad.sequenceNo != null ? String(ad.sequenceNo) : "",
                product: ad.product?._id || (typeof ad.product === "string" ? ad.product : ""),
                placement: ad.isTopImage ? "top" : ad.isBottomImage ? "bottom" : "standard",
                // link: ad.link || "",
            },
            start: ad.validityStartDate ? new Date(ad.validityStartDate) : null,
            end,
            excluded: (ad.excludedOutlets || []).map((o) => (
                outletOptions.find((x) => x.value === o._id) || { value: o._id, label: o.name }
            )),
        };
    };

    const addInitial = {
        id: null, imageUrl: null,
        form: { title: "", type: "CLICKABLE", sequenceNo: "", product: "", placement: "standard" },
        start: null, end: null, excluded: [],
    };

    const saveAd = async (formData) => {
        const isEdit = formState?.mode === "edit";
        setSaving(true);
        try {
            const headers = { "Content-Type": "multipart/form-data", ...authHeaders };
            const response = isEdit
                ? await axiosInstance.put("advertisement", formData, { headers })
                : await axiosInstance.post("advertisement", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, TOAST);
                setFormState(null);
                getAdvertisementList();
            }
        } catch (error) {
            if (error?.response) toast.error(getErrMsg(error), TOAST);
        } finally {
            setSaving(false);
        }
    };

    const saveImage = async (file) => {
        setIsImageUpdating(true);
        try {
            const formData = new FormData();
            formData.append("_id", imageAd._id);
            formData.append("adImage", file);
            const headers = { "Content-Type": "multipart/form-data", ...authHeaders };
            const response = await axiosInstance.put("advertisement", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, TOAST);
                setImageAd(null);
                getAdvertisementList();
            }
        } catch (error) {
            if (error?.response) toast.error(getErrMsg(error), TOAST);
        } finally {
            setIsImageUpdating(false);
        }
    };

    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
            const response = await axiosInstance.delete("advertisement", { data: { _id: deleteAd._id }, headers: authHeaders });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, TOAST);
                setDeleteAd(null);
                getAdvertisementList();
            }
        } catch (error) {
            if (error?.response) toast.error(getErrMsg(error), TOAST);
        } finally {
            setIsDeleting(false);
        }
    };

    const openView = (ad) => {
        setViewAd(ad);
        setSingleAd(null);
        getSingleAdvertisement(ad._id);
    };

    const drawerAd = viewAd ? (singleAd && singleAd._id === viewAd._id ? { ...viewAd, ...singleAd } : viewAd) : null;

    // ---------- render data ----------

    const statCards = [
        { label: "Total Advertisements", value: counts.ALL, icon: "bi-card-image", cls: "total" },
        { label: "Active", value: counts.ACTIVE, icon: "bi-eye-fill", cls: "active" },
        { label: "Inactive", value: counts.INACTIVE, icon: "bi-pause-circle-fill", cls: "inactive" },
        { label: "Excluded Outlets", value: counts.EXCLUDED, icon: "bi-eye-slash-fill", cls: "excluded" },
    ];

    const tabs = [
        { key: "ALL", label: "All" },
        { key: "CLICKABLE", label: "Clickable" },
        { key: "NON_CLICKABLE", label: "Non Clickable" },
        { key: "TOP_BANNER", label: "Top Banner" },
        { key: "BOTTOM_BANNER", label: "Bottom Banner" },
    ];

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4 adm-page">

                {/* ---------- Banner ---------- */}
                <div className="adm-banner">
                    <div className="adm-banner-icon"><i className="bi bi-megaphone-fill" /></div>
                    <div className="adm-banner-text">
                        <h4>Advertisement Management</h4>
                        <p>Create, manage and monitor all advertisements.</p>
                    </div>
                    <div className="adm-art d-none d-xl-block" aria-hidden="true">
                        <div className="adm-art-card"><i className="bi bi-image" /></div>
                        <span className="adm-art-badge"><i className="bi bi-send-fill" /></span>
                    </div>
                    <div className="adm-banner-actions">
                        <button className="adm-btn-ghost" onClick={handleRefresh} disabled={isRefreshBtnLoading}>
                            {isRefreshBtnLoading ? <Spinner size="sm" /> : <><i className="bi bi-arrow-clockwise" /> Clear Cache</>}
                        </button>
                        {hasPerm("add") && (
                            <button className="adm-btn-solid" onClick={() => setFormState({ mode: "add" })}>
                                <i className="bi bi-plus-lg" /> Add New Advertisement
                            </button>
                        )}
                    </div>
                </div>

                {/* ---------- Filters ---------- */}
                <div className="adm-card adm-filters">
                    <div className="adm-search">
                        <i className="bi bi-search" />
                        <input
                            placeholder="Search by title or product..."
                            value={searchText} onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>
                    <Form.Select className="adm-input adm-status-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                        <option value="">All Status</option>
                        <option value="ACTIVE">Active</option>
                        <option value="INACTIVE">Inactive</option>
                        <option value="SCHEDULED">Scheduled</option>
                        <option value="EXPIRED">Expired</option>
                    </Form.Select>
                    <div className="adm-outlet-select">
                        <Select
                            styles={selectStyles} menuPortalTarget={document.body}
                            options={outletOptions} value={outletFilter} onChange={setOutletFilter}
                            isClearable placeholder="Filter by Outlet"
                        />
                    </div>
                    <button className="adm-clear" onClick={clearFilters}>
                        <i className="bi bi-arrow-repeat" /> Clear
                    </button>

                    {/* ---------- Stats ---------- */}
                    <div className="adm-stats">
                        {statCards.map((s) => (
                            <div key={s.label} className={`adm-stat ${s.cls}`}>
                                <div className="adm-stat-icon"><i className={`bi ${s.icon}`} /></div>
                                <div>
                                    <div className="adm-stat-value">{s.value}</div>
                                    <div className="adm-stat-label">{s.label}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* ---------- Tabs ---------- */}
                    <div className="adm-tabs">
                        {tabs.map(t => (
                            <button key={t.key} className={activeTab === t.key ? "is-active" : ""} onClick={() => setActiveTab(t.key)}>
                                {t.label} ({counts[t.key] || 0})
                            </button>
                        ))}
                    </div>

                    {/* ---------- Table ---------- */}
                    <div className="adm-table-wrap">
                        <div className="table-responsive">
                            <Table hover className="mb-0 align-middle adm-table">
                                <thead>
                                    <tr>
                                        <th className="ps-4">SR.NO</th>
                                        <SortTh label="ADVERTISEMENT" k="title" sort={sort} onSort={toggleSort} />
                                        <SortTh label="TYPE" k="type" sort={sort} onSort={toggleSort} />
                                        <SortTh label="STATUS" k="status" sort={sort} onSort={toggleSort} />
                                        <SortTh label="VALIDITY" k="validity" sort={sort} onSort={toggleSort} />
                                        <th>EXCLUDED OUTLETS</th>
                                        <th>ACTIONS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listLoading ? (
                                        Array.from({ length: PAGE_SIZE }).map((_, i) => (
                                            <tr key={i}>
                                                <td colSpan={7} className="py-3 px-4"><div className="adm-skeleton" /></td>
                                            </tr>
                                        ))
                                    ) : pagedAds.length === 0 ? (
                                        <tr>
                                            <td colSpan={7} className="text-center text-muted py-5">
                                                <i className="bi bi-megaphone d-block mb-2" style={{ fontSize: "2rem", opacity: 0.4 }} />
                                                No advertisements match your filters.
                                                {hasPerm("add") && allAds.length === 0 && (
                                                    <div className="mt-2">
                                                        <Button size="sm" className="adm-primary" onClick={() => setFormState({ mode: "add" })}>Add your first advertisement</Button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ) : pagedAds.map((ad, index) => (
                                        <tr key={ad._id}>
                                            <td className="ps-4">{index + 1 + (page - 1) * PAGE_SIZE}</td>
                                            <td>
                                                <div className="d-flex align-items-center gap-3">
                                                    <Image src={ad.adImagePath} alt={ad.title} className="adm-thumb" />
                                                    <div>
                                                        <div className="fw-semibold" style={{ fontSize: 14.5, color: "#1B1F27" }}>{ad.title}</div>
                                                        <div className="text-muted" style={{ fontSize: 13 }}>{ad.product?.name || "—"}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td><CategoryBadge category={ad._category} /></td>
                                            <td><StatusBadge status={getAdStatus(ad)} /></td>
                                            <td style={{ fontSize: 14 }}>
                                                {ad.validityStartDate && ad.validityEndDate
                                                    ? `${fmtDate(ad.validityStartDate)} - ${fmtDate(ad.validityEndDate)}`
                                                    : <span className="text-muted">No expiry</span>}
                                            </td>
                                            <td style={{ fontSize: 14 }}>
                                                {ad.excludedOutlets?.length ? `${ad.excludedOutlets.length} outlet(s)` : "All Outlets"}
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    {hasPerm("get") && (
                                                        <button className="adm-icon-btn" title="View" aria-label="View details" onClick={() => openView(ad)}>
                                                            <i className="bi bi-eye" />
                                                        </button>
                                                    )}
                                                    {hasPerm("update") && (
                                                        <button className="adm-icon-btn" title="Edit" aria-label="Edit advertisement" onClick={() => setFormState({ mode: "edit", ad })}>
                                                            <i className="bi bi-pencil" />
                                                        </button>
                                                    )}
                                                    {(hasPerm("update") || hasPerm("delete")) && (
                                                        <Dropdown align="end">
                                                            <Dropdown.Toggle variant="light" className="adm-icon-btn adm-no-caret" aria-label="More actions" id={`ad-menu-${ad._id}`}>
                                                                <i className="bi bi-three-dots-vertical" />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu renderOnMount popperConfig={{ strategy: "fixed" }}>
                                                                {hasPerm("update") && (
                                                                    <Dropdown.Item onClick={() => setImageAd(ad)}>
                                                                        <i className="bi bi-image me-2" /> Change image
                                                                    </Dropdown.Item>
                                                                )}
                                                                {hasPerm("delete") && (
                                                                    <Dropdown.Item className="text-danger" onClick={() => setDeleteAd(ad)}>
                                                                        <i className="bi bi-trash me-2" /> Delete
                                                                    </Dropdown.Item>
                                                                )}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>

                    {/* ---------- Pagination ---------- */}
                    <div className="adm-footer">
                        <span className="text-muted" style={{ fontSize: 13.5 }}>
                            Showing {filteredAds.length === 0 ? 0 : (page - 1) * PAGE_SIZE + 1} to {Math.min(page * PAGE_SIZE, filteredAds.length)} of {filteredAds.length} entries
                        </span>
                        <div className="adm-pager">
                            <button disabled={page === 1} onClick={() => setPage(p => Math.max(1, p - 1))} aria-label="Previous page">
                                <i className="bi bi-chevron-left" />
                            </button>
                            {pageNumbers.map(n => (
                                <button key={n} className={page === n ? "is-active" : ""} onClick={() => setPage(n)}>{n}</button>
                            ))}
                            <button disabled={page === totalPages} onClick={() => setPage(p => Math.min(totalPages, p + 1))} aria-label="Next page">
                                <i className="bi bi-chevron-right" />
                            </button>
                        </div>
                    </div>
                </div>

                {/* ---------- Overlays ---------- */}
                {formState && (
                    <AdFormModal
                        mode={formState.mode}
                        initial={formState.mode === "edit" ? buildEditInitial(formState.ad) : addInitial}
                        outletOptions={outletOptions}
                        products={productsList}
                        saving={saving}
                        onClose={() => setFormState(null)}
                        onSave={saveAd}
                    />
                )}

                <ViewDrawer
                    ad={drawerAd}
                    loading={detailLoading}
                    can={hasPerm}
                    onClose={() => setViewAd(null)}
                    onEdit={(ad) => { setViewAd(null); setFormState({ mode: "edit", ad }); }}
                    onImage={(ad) => { setViewAd(null); setImageAd(ad); }}
                    onDelete={(ad) => { setViewAd(null); setDeleteAd(ad); }}
                />

                {imageAd && (
                    <ChangeImageModal ad={imageAd} saving={isImageUpdating} onClose={() => setImageAd(null)} onSave={saveImage} />
                )}

                {deleteAd && (
                    <Modal show onHide={isDeleting ? undefined : () => setDeleteAd(null)} centered>
                        <Modal.Body className="text-center p-4">
                            <div className="adm-del-icon"><i className="bi bi-trash3" /></div>
                            <h5 className="fw-bold mb-1">Delete this advertisement?</h5>
                            <p className="text-muted mb-4">
                                <b>{deleteAd.title}</b> will be removed permanently. This can't be undone.
                            </p>
                            <div className="d-flex gap-2 justify-content-center">
                                <Button variant="light" className="border fw-semibold px-4" onClick={() => setDeleteAd(null)} disabled={isDeleting}>Cancel</Button>
                                <Button variant="danger" className="fw-semibold px-4" onClick={confirmDelete} disabled={isDeleting}>
                                    {isDeleting ? <Spinner size="sm" /> : "Delete"}
                                </Button>
                            </div>
                        </Modal.Body>
                    </Modal>
                )}
            </div>

            <style>{CSS}</style>
        </React.Fragment>
    );
};

/* ======================= styles ======================= */

const CSS = `
.adm-page { background:#F5F6FA; padding:14px !important; }
@media (min-width: 992px) { .adm-page { padding:18px !important; } }

.adm-drop-actions { position:absolute; right:10px; bottom:10px; display:flex; gap:8px; }


.adm-ad-modal .modal-content { max-height: calc(100vh - 3.5rem); }
.adm-ad-modal form { display: flex; flex-direction: column; min-height: 0; flex: 1 1 auto; overflow: hidden; }
.adm-ad-modal .modal-body { overflow-y: auto; min-height: 0; }
.adm-ad-modal .modal-header,
.adm-ad-modal .modal-footer { flex-shrink: 0; }

.adm-drawer { width:min(460px,100vw) !important; }

.adm-primary, .adm-primary:hover, .adm-primary:focus, .adm-primary:active { background:#4F52F0 !important; border-color:#4F52F0 !important; color:#fff !important; border-radius:9px; }
.adm-primary:hover { background:#4144D6 !important; }

.adm-input { height:40px; border-radius:9px; border:1px solid #E3E6EC; font-size:13.5px; }
.adm-input:focus { border-color:#4F46E5; box-shadow:0 0 0 3px rgba(79,70,229,.12); }
.adm-label { font-weight:600; font-size:13px; color:#1B1F27; margin-bottom:5px; }
.adm-section { font-weight:700; font-size:13.5px; color:#1B1F27; padding-bottom:6px; margin-bottom:12px; border-bottom:1px solid #EEF0F4; }
.react-datepicker-popper { z-index:2100 !important; }

/* banner */
.adm-banner { position:relative; display:flex; align-items:center; gap:16px; padding:16px 18px; border-radius:12px; color:#fff; margin-bottom:14px; overflow:hidden; background:linear-gradient(135deg,#1B2257 0%,#272D72 100%); flex-wrap:wrap; }
.adm-banner-icon { width:48px; height:48px; border-radius:12px; background:linear-gradient(135deg,#6366F1,#7C5CF0); display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
.adm-banner-text { flex:1; min-width:220px; }
.adm-banner-text h4 { margin:0 0 2px; font-weight:700; color:#fff; font-size:1.15rem; line-height:1.3; }
.adm-banner-text p { margin:0; color:#C9CEF2; font-size:13.5px; }
.adm-banner-actions { display:flex; gap:10px; flex-wrap:wrap; position:relative; z-index:1; }
.adm-btn-ghost, .adm-btn-solid { height:42px; padding:0 16px; border-radius:9px; font-weight:600; font-size:13.5px; display:inline-flex; align-items:center; gap:7px; cursor:pointer; transition:background .15s; }
.adm-btn-ghost { background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.35); color:#fff; }
.adm-btn-ghost:hover { background:rgba(255,255,255,.12); }
.adm-btn-solid { background:#4F52F0; border:1px solid #4F52F0; color:#fff; }
.adm-btn-solid:hover { background:#5E61FF; }
.adm-art { position:relative; width:130px; height:74px; margin-right:14px; align-self:flex-end; }
.adm-art-card { position:absolute; left:18px; top:12px; width:96px; height:78px; border-radius:11px 11px 0 0; background:linear-gradient(160deg,rgba(255,255,255,.22),rgba(255,255,255,.06)); border:1px solid rgba(255,255,255,.25); transform:perspective(300px) rotateY(-14deg) rotateX(6deg); display:flex; align-items:center; justify-content:center; font-size:34px; color:#8FA2FF; }
.adm-art-badge { position:absolute; right:4px; top:0; width:34px; height:23px; border-radius:7px; background:#C084FC; display:flex; align-items:center; justify-content:center; font-size:11px; transform:rotate(8deg); }

/* main card + filters */
.adm-card { background:#fff; border:1px solid #EEF0F4; border-radius:12px; box-shadow:0 1px 3px rgba(16,24,40,.04); }
.adm-filters { padding:14px; display:grid; grid-template-columns:minmax(220px,4fr) minmax(160px,3fr) minmax(180px,3fr) auto; gap:10px; align-items:center; }
.adm-filters > .adm-stats, .adm-filters > .adm-tabs, .adm-filters > .adm-table-wrap, .adm-filters > .adm-footer { grid-column:1 / -1; }
.adm-search { position:relative; }
.adm-search i { position:absolute; left:13px; top:50%; transform:translateY(-50%); color:#8A93A3; font-size:14px; }
.adm-search input { width:100%; height:40px; border-radius:9px; border:1px solid #E3E6EC; padding:0 13px 0 36px; font-size:13.5px; outline:none; }
.adm-search input:focus { border-color:#4F46E5; box-shadow:0 0 0 3px rgba(79,70,229,.12); }
.adm-clear { height:40px; padding:0 15px; border-radius:9px; border:1px solid #E3E6EC; background:#F8F9FB; font-weight:600; font-size:13.5px; display:inline-flex; align-items:center; gap:7px; color:#1B1F27; }
.adm-clear:hover { background:#EEF0F4; }

/* stats */
.adm-stats { display:grid; grid-template-columns:repeat(4,1fr); gap:12px; margin-top:2px; }
.adm-stat { display:flex; align-items:center; gap:12px; padding:14px 16px; border-radius:11px; border:1px solid; }
.adm-stat-icon { width:42px; height:42px; border-radius:11px; display:flex; align-items:center; justify-content:center; font-size:19px; }
.adm-stat-value { font-size:20px; font-weight:700; line-height:1.1; }
.adm-stat-label { font-size:12.5px; color:#4B5563; }
.adm-stat.total { background:linear-gradient(135deg,#F0F2FF,#F8F9FF); border-color:#E2E6FF; } .adm-stat.total .adm-stat-icon { background:#E1E6FF; color:#4F52F0; } .adm-stat.total .adm-stat-value { color:#27307A; }
.adm-stat.active { background:linear-gradient(135deg,#ECF9F1,#F5FCF8); border-color:#D3EFE0; } .adm-stat.active .adm-stat-icon { background:#D3F1E1; color:#1F9254; } .adm-stat.active .adm-stat-value { color:#1F9254; }
.adm-stat.inactive { background:linear-gradient(135deg,#FFF6EA,#FFFAF3); border-color:#FBE5C5; } .adm-stat.inactive .adm-stat-icon { background:#FCE6C3; color:#E58A00; } .adm-stat.inactive .adm-stat-value { color:#D97706; }
.adm-stat.excluded { background:linear-gradient(135deg,#FFF0F1,#FFF7F8); border-color:#FBD9DC; } .adm-stat.excluded .adm-stat-icon { background:#FAD3D7; color:#D93025; } .adm-stat.excluded .adm-stat-value { color:#D93025; }

/* tabs */
.adm-tabs { display:flex; flex-wrap:wrap; gap:8px; }
.adm-tabs button { border:1px solid #E3E6EC; background:#fff; color:#374151; font-weight:600; font-size:13px; border-radius:999px; padding:7px 15px; transition:all .15s; }
.adm-tabs button:hover { border-color:#C7CBFF; color:#4F46E5; }
.adm-tabs button.is-active { background:#4F52F0; border-color:#4F52F0; color:#fff; }

/* table */
.adm-table-wrap { border:1px solid #EEF0F4; border-radius:11px; overflow:hidden; }
.adm-table thead th { background:#fff; font-size:12px; font-weight:600; color:#6B7280; padding:12px 10px; border-bottom:1px solid #EEF0F4; white-space:nowrap; }
.adm-table tbody td { padding:10px; border-bottom:1px solid #F1F2F4; }
.adm-table tbody tr:last-child td { border-bottom:0; }
.adm-table tbody tr:hover > * { background:#FAFAFF; }
.adm-sortable { cursor:pointer; user-select:none; }
.adm-thumb { width:120px; height:48px; object-fit:cover; border-radius:6px; border:1px solid #EEF0F4; }
.adm-status { display:inline-flex; align-items:center; gap:6px; font-weight:600; font-size:12px; border-radius:999px; padding:3px 10px; }
.adm-dot { width:6px; height:6px; border-radius:50%; display:inline-block; }
.adm-type { font-weight:600; font-size:12px; border-radius:6px; padding:3px 9px; white-space:nowrap; }
.adm-icon-btn { width:32px; height:32px; border-radius:9px; border:0; background:#F3F4F6; color:#374151; display:inline-flex; align-items:center; justify-content:center; padding:0; font-size:13.5px; transition:background .15s; }
.adm-icon-btn:hover, .adm-icon-btn:focus, .adm-icon-btn:active, .show > .adm-icon-btn.btn-light { background:#E5E7EB !important; color:#111827 !important; }
.adm-no-caret::after { display:none !important; }
.adm-skeleton { height:34px; border-radius:8px; background:linear-gradient(90deg,#f0f0f0 25%,#e6e6e6 50%,#f0f0f0 75%); background-size:200% 100%; animation:admPulse 1.5s infinite; }
@keyframes admPulse { 0% { background-position:200% 0; } 100% { background-position:-200% 0; } }
.adm-footer { display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:10px; }
.adm-pager { display:flex; gap:5px; }
.adm-pager button { min-width:34px; height:34px; border-radius:9px; border:1px solid #E3E6EC; background:#fff; font-weight:600; font-size:13px; color:#374151; }
.adm-pager button:disabled { opacity:.45; }
.adm-pager button.is-active { background:#4F52F0; border-color:#4F52F0; color:#fff; }

/* form */
.adm-choices { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
.adm-choice { display:flex; align-items:center; gap:10px; text-align:left; padding:10px 12px; border:1.5px solid #E3E6EC; border-radius:11px; background:#fff; transition:all .15s; }
.adm-choice i { font-size:18px; color:#8A93A3; }
.adm-choice b { display:block; font-size:13.5px; color:#1B1F27; }
.adm-choice small { color:#6B7280; font-size:12px; }
.adm-choice.is-active { border-color:#4F52F0; background:#F3F4FF; box-shadow:0 0 0 3px rgba(79,82,240,.1); }
.adm-choice.is-active i { color:#4F52F0; }
.adm-segment { display:inline-flex; background:#F3F4F6; border-radius:9px; padding:4px; margin-bottom:5px; }
.adm-segment button { border:0; background:transparent; padding:7px 14px; border-radius:7px; font-size:13px; font-weight:600; color:#4B5563; }
.adm-segment button.is-active { background:#fff; color:#4F52F0; box-shadow:0 1px 3px rgba(16,24,40,.12); }
.adm-drop { border:2px dashed #CBD0DA; border-radius:11px; padding:22px 14px; text-align:center; background:#FAFAFC; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:3px; transition:all .15s; }
.adm-drop i { font-size:28px; color:#4F52F0; }
.adm-drop:hover, .adm-drop.is-drag, .adm-drop:focus-visible { border-color:#4F52F0; background:#F3F4FF; outline:none; }
.adm-drop.is-error { border-color:#D93025; background:#FFF8F8; }
.adm-drop-preview { position:relative; border-radius:11px; overflow:hidden; border:1px solid #E3E6EC; background:#F3F4F6; }
.adm-drop-preview img { width:100%; max-height:210px; object-fit:contain; display:block; }
.adm-drop-actions { position:absolute; right:10px; bottom:10px; display:flex; gap:8px; }

/* drawer */
.adm-drawer { width:min(460px,100vw) !important; }
.adm-hero { border-radius:11px; overflow:hidden; background:#F3F4F6; border:1px solid #EEF0F4; }
.adm-hero img { width:100%; display:block; object-fit:contain; }
.adm-info-card { border:1px solid #EEF0F4; border-radius:11px; padding:2px 14px; }
.adm-info { display:flex; gap:10px; padding:11px 0; border-bottom:1px solid #F1F2F4; }
.adm-info:last-child { border-bottom:0; }
.adm-info-icon { width:30px; height:30px; border-radius:9px; background:#EEF0FF; color:#4F52F0; display:flex; align-items:center; justify-content:center; font-size:13.5px; flex-shrink:0; }
.adm-info-label { font-size:12px; color:#6B7280; }
.adm-info-value { font-size:13.5px; font-weight:600; color:#1B1F27; }
.adm-hint { font-size:12px; font-weight:500; color:#6B7280; }
.adm-chip { background:#F1F2F4; color:#374151; font-size:11.5px; font-weight:600; border-radius:6px; padding:3px 7px; }
.adm-product { display:flex; gap:12px; border:1px solid #EEF0F4; border-radius:11px; padding:10px; }
.adm-product img { width:64px; height:64px; border-radius:9px; object-fit:cover; background:#F3F4F6; }
.adm-drawer-footer { display:flex; gap:9px; padding:12px 14px; border-top:1px solid #EEF0F4; background:#fff; }
.adm-drawer-footer .btn { height:40px; border-radius:9px; font-size:13.5px; }
.adm-del-icon { width:50px; height:50px; border-radius:50%; background:#FDEBEC; color:#D93025; display:flex; align-items:center; justify-content:center; font-size:21px; margin:0 auto 12px; }

@media (max-width: 991px) {
  .adm-filters { grid-template-columns:1fr 1fr; }
  .adm-stats { grid-template-columns:1fr 1fr; }
}
@media (max-width: 575px) {
  .adm-filters { grid-template-columns:1fr; }
  .adm-stats { grid-template-columns:1fr; }
  .adm-choices { grid-template-columns:1fr; }
}
`;

export default AdvertisementMgt;